export interface PaisesDestinoType {
	[country: string]: string[];
}

export const PaisesDestino: PaisesDestinoType = {
	'Al Asimah': ['Kuwait'],
	Albania: [
		'Agioi',
		'Agirocastro',
		'Akçehisar',
		'Aulon',
		'Avlona',
		'Cruja',
		'Cucus',
		'Drac',
		'Durrës',
		'Dyrrakhion',
		'Elbasan',
		'Ergiri',
		'Fier',
		'Fier-Çifçi',
		'Fjeri',
		'Fushë-Krujë',
		'Ghinokastre',
		'Ghiortsa Corcia',
		'Gjirokastër',
		'Gorica',
		'Librazhd-Qendër',
		'Lješ',
		'Ljushna Cod a Gomares',
		'Ljušnje',
		'Lyesh',
		'Patos Fshat',
		'Porto Edda',
		'Qyteti Stalin',
		'Rrëshen',
		'Rshen',
		'Santa Quaranta',
		'Shkodër',
		'Šjak',
		'Tirana',
		'Tyranna',
		'Valona',
		'Verati',
		'Vlorë',
		'Zogaj'
	],
	Alemania: [
		'Aachen',
		'Aalen',
		'Achern',
		'Achim',
		'Aerding',
		'Aerzen',
		'Ahaus',
		'Ahlen',
		'Ahrensburg',
		'Aibling',
		'Aichach',
		'Ainring',
		'Aix-la-Chapelle',
		'Altdorf bei Nürnberg',
		'Alt-Hohenschönhausen',
		'Alt-Marl',
		'Alzenau in Unterfranken',
		'Amberg',
		'Apen',
		'Aplerbeck',
		'Apolda',
		'Aquisgrán',
		'Arnsberg',
		'Aschaffenburg',
		'Aschersleben',
		'Attendorn',
		'Auerbach',
		'Augsburgo',
		'Augusta Ubiorum',
		'Augusta Vindelicorum',
		'Aurich',
		'Auscheffenburg',
		'Bad Driburg',
		'Bad Homburg',
		'Bad Honnef am Rhein',
		'Bad Iburg',
		'Bad Neuenahr-Ahrweiler',
		'Bad Oeynhausen',
		'Bad Pyrmont',
		'Bad Wünnenberg',
		'Bad Wurzach',
		'Bad Zwischenahn',
		'Bergedorf',
		'Bergheim an der Erft',
		'Bergisch Gladbach',
		'Berlín',
		'Berlin-Adlershof',
		'Berlin-Charlottenburg',
		'Berlin-Friedrichsfelde',
		'Berlin-Johannisthal',
		'Berlin-Oberschöneweide',
		'Bielefeld',
		'Billstedt',
		'Bingen am Rhein',
		'Blankenese',
		'Blasewitz',
		'Blieskastel',
		'Bochum',
		'Bochum-Hordel',
		'Böhl-Iggelheim',
		'Bonn',
		'Borbetomagus',
		'Bottrop',
		'Brake (Unterweser)',
		'Bremen',
		'Bremerhaven',
		'Brunswick',
		'Buchen in Odenwald',
		'Carlsruhe',
		'Castrop-Rauxel',
		'Celle',
		'Chemnitz',
		'Ciudad de Brandeburgo',
		"Ciutat d'Hamburg",
		'Cladow',
		'Clausthal-Zellerfeld',
		'Cléveris',
		'Cloppenburg',
		'Coblenza',
		'Colonia',
		'Colonia Agrippinensis',
		'Constanza',
		'Cottbus',
		'Crefeld',
		'Crimmitschau',
		'Cronberg in Taunus',
		'Culmbach',
		'Cuxhaven',
		'Dachau',
		'Darmstadt',
		'Datteln',
		'Delmenhorst',
		'Dessau',
		'Dessau-Roßlau',
		'Detmold',
		'Districte dAltona',
		'Districte dHarburg',
		'Dormagen',
		'Dorsten',
		'Dortmund',
		'Dos Puentes',
		'Dreieich',
		'Dresde',
		'Duisburg and Hamborn',
		'Duisburg-Hamborn',
		'Duisburgo',
		'Dülmen',
		'Düren',
		'Düsseldorf',
		'Eberbach',
		'Ebersbachander Fils',
		'Ebersberg',
		'Eberswalde',
		'Eching',
		'Eckernförde',
		'Edewecht',
		'Edingen-Neckarhausen',
		'Eggenfelden',
		'Eggenstein-Leopoldshafen',
		'Ehingen Donau',
		'Eichenau',
		'Eichstätt',
		'Eidelstedt',
		'Eilbek',
		'Eilenburg',
		'Eimsbüttel',
		'Einbeck',
		'Eisenach',
		'Eisenberg',
		'Eisenhüttenstadt',
		'Eislingen-Fils',
		'Eissendorf',
		'Eitorf',
		'Elmshorn',
		'Emden',
		'Emmendingen',
		'Emmerich am Rhein',
		'Emsdetten',
		'Emstek',
		'Endersbach',
		'Engelskirchen',
		'Enger',
		'Eningen unter Achalm',
		'Ennepetal',
		'Ennigerloh',
		'Eppelborn',
		'Eppelheim',
		'Eppendorf',
		'Eppingen',
		'Eppstein',
		'Erbach im Odenwald',
		'Erding',
		'Erftstadt',
		'Érfurt',
		'Erkelenz',
		'Erkrath',
		'Erlangen',
		'Erlenbach über Klingenberg',
		'Eschweiler',
		'Espira',
		'Essen',
		'Esslingen am Neckar',
		'Estat de Berlín',
		"Estat d'Hamburg",
		'Ettenheim',
		'Ettlingen',
		'Euskirchen',
		'Eutin',
		'Eutin mit Malente',
		'Eving',
		'Falkenhagener Feld',
		'Falkensee',
		'Farmsen-Berne',
		'Fellbach',
		'Fennpfuhl',
		'Filderstadt',
		'Finsterwalde',
		'Fischeln',
		'Flensburgo',
		'Floeha',
		'Flörsheim',
		'Forchheim',
		'Forst',
		'Fráncfort del Meno',
		'Fráncfort del Óder',
		'Frankenthal',
		'Frankfurt am Main',
		'Frechen',
		'Freiberg',
		'Freital',
		'Friburgo de Brisgovia',
		'Friedberg bei Augsburg',
		'Friedrichshafen',
		'Frisinga',
		'Fuerstenberg',
		'Fuhlsbüttel',
		'Fulda',
		'Fuldatal',
		'Fürstenfeldbruck',
		'Fürstenwalde',
		'Fürth',
		'Füssen',
		'Garbsen',
		'Gelsenkirchen',
		'Gera',
		'Germering',
		'Gesundbrunnen',
		'Giengen',
		'Giessen',
		'Gifhorn',
		'Gladbeck',
		'Gladenbach',
		'Glauchau',
		'Glinde',
		'Glückstadt',
		'Gohlis',
		'Göppingen',
		'Görlitz',
		'Goslar',
		'Gotha',
		'Gotinga',
		'Greifswald',
		'Grenzach-Wyhlen',
		'Grevenbroich',
		'Groß Lichterfelde',
		'Groß-Umstadt',
		'Groß-Zimmern',
		'Großzschocher',
		'Groß-Zschocher-Windorf',
		'Güeldres',
		'Gummersbach',
		'Güstrow',
		'Gütersloh',
		'Hagen',
		'Halle',
		'Halle an der Saale',
		'Hamburg-Mitte',
		'Hamburg-Nord',
		'Hamburgo',
		'Hamburgo-Altona',
		'Hamburgo-Harburgo',
		'Hamburg-Wandsbek',
		'Hamm',
		'Hanau',
		'Hanóver',
		'Harburg an Elbe',
		'Heidelberg',
		'Heidenheim in Württemberg',
		'Heilbronn',
		'Heilbronn Neckar',
		'Hellersdorf',
		'Herford',
		'Herne',
		'Herten',
		'Hiddenhausen',
		'Hieronymusstadt',
		'Hilden',
		'Hildesheim',
		'Höchst im Odenwald',
		'Höchstadt an der Aisch',
		'Hof',
		'Homberg (Efze)',
		'Homburg',
		'Homburg vor der Höhe',
		'Honovere',
		'Hoyerswerda',
		'Hückelhoven',
		'Hückeswagen',
		'Hude',
		'Hürth',
		'Husum',
		'Ibbenbueren',
		'Idar-Oberstein',
		'Idstein',
		'Illertissen',
		'Illingen',
		'Ilmenau',
		'Ilsede',
		'Immenstadt im Allgäu',
		'Ingelheim',
		'Ingelheim am Rhein',
		'Ingolstadt',
		'Iserlohn',
		'Isernhagen Farster Bauerschaft',
		'Itzehoe',
		'Jena',
		'Jena (Thueringen)',
		'Jüchen',
		'Jülich',
		'Jüterbog',
		'Kaiserslautern',
		'Karlsruhe',
		'Kassel',
		'Kehl am Rhein',
		'Kempten (Allgäu)',
		'Kerpen',
		'Kiel',
		'Kirchheim unter Teck',
		'Kleinzschocher',
		'Kleve',
		'Klotzsche',
		'Koblenz',
		'Koeln',
		'Königs Wusterhausen',
		'Kottbus',
		'Krefeld',
		'Krefeld-Uerdingen',
		'Kreuzau über Düren',
		'Kreuzberg',
		'Kyle',
		'Kyritz',
		'Lahr',
		'Landau',
		'Landau in der Pfalz',
		'Landshut',
		'Langendorf',
		'Langenfeld',
		'Langenhagen',
		'Langenhorn',
		'Lauchhammer East',
		'Leinfelden-Echterdingen',
		'Leipzig',
		'Leudenscheid',
		'Leverkusen',
		'Limbach-Oberfrohna',
		'Lipsk',
		'Loerrach',
		'Lübben (Spreewald)',
		'Lubeca',
		'Lübeck Hansestadt',
		'Lüdenscheid',
		'Ludwigshafen',
		'Ludwigshafen am Rhein',
		'Luisburgo',
		'Luneburgo',
		'Lünen',
		'Lutra',
		'Magdeburg-Neustadt',
		'Magdeburgo',
		'Maguncia',
		'Mannheim',
		'Marburg an der Lahn',
		'Minden',
		'Mitte',
		'Moabit',
		'Moers',
		'Mogontiacum',
		'Mönchengladbach',
		'Monheim am Rhein',
		'Muenchen-Gladbach',
		'Mühldorf am Inn',
		'Mühlhausen',
		'Mülheim am Rhein',
		'Mülheim an der Ruhr',
		'Múnich',
		'Münster',
		'Neu Isenburg',
		'Neu Wulmstorf',
		'Neubrandenburg',
		'Neugraben-Fischbek',
		'Neuhausen auf den Fildern',
		'Neu-Hohenschönhausen',
		'Neukirchen-Vluyn',
		'Neukölln',
		'Neumünster',
		'Neuss',
		'Neustadt am Rübenberge',
		'Neustadt an der Aisch',
		'Neustadt an der Weinstraße',
		'Neuwied',
		'Nieder-Ingelheim',
		'Nippes',
		'Norderstedt',
		'Nuevo Brandeburgo',
		'Nuevo Ulm',
		'Nümbrecht',
		'Nuremberg',
		'Núremberg',
		'Nürtingen',
		'Nußloch',
		'Oberhausen',
		'Obernkirchen',
		'Ober-Ramstadt',
		'Oberschleißheim',
		'Obertshausen',
		'Oberursel',
		'Ochsenfurt',
		'Ochtrup',
		'Odenthal',
		'Oelde',
		'Oelsnitz',
		'Oer-Erkenschwick',
		'Oerlinghausen',
		'Offenbach',
		'Offenburg',
		'Oftersheim',
		'Ohlsdorf',
		'Öhringen',
		'Oldenburg',
		'Olpe',
		'Opladen',
		'Oppum',
		'Oranienburg',
		'Osnabrück',
		'Osterholz-Scharmbeck',
		'Ostfildern',
		'Othmarschen',
		'Ottendorf-Okrilla',
		'Ottensen',
		'Ottersberg',
		'Ottobrunn bei München',
		'Ottweiler',
		'Overath',
		'Oyten',
		'Paderborn',
		'Pfaffenhofen an der Ilm',
		'Pfarrkirchen',
		'Pforzheim',
		'Pfullendorf',
		'Pfullingen',
		'Pfungstadt',
		'Philippsburg',
		'Pinneberg',
		'Pirmasens',
		'Plauen',
		'Please change the population to 9694',
		'Plettenberg',
		'Porz am Rhein',
		'Potsdam',
		'Prenzlauer Berg',
		'Pulheim',
		'Quakenbrück',
		'Quedlinburg',
		'Quickborn',
		'Rahlstedt',
		'Rastatt',
		'Ratingen',
		'Ratisbona',
		'Ravensburg',
		'Recklinghausen',
		'Regensburg',
		'Reinickendorf',
		'Remscheid',
		'Reutlingen',
		'Rheda-Wiedenbrück',
		'Rhede',
		'Rheinbach',
		'Rheinberg',
		'Rheine',
		'Rheinfelden',
		'Rheinhausen',
		'Rheinstetten',
		'Riesa',
		'Rodenkirchen',
		'Rosenheim',
		'Rostock',
		'Rotenburg (Wümme)',
		'Rotenburg an der Fulda',
		'Rothenburg upon Tauber',
		'Rudolstadt',
		'Rudow',
		'Rüsselsheim am Main',
		'Sankt Augustin',
		'Sankt Ingbert',
		'Sarrebruck',
		'Schöneberg',
		'Schwabach',
		'Schwäbisch Gmünd',
		'Schwäbisch Hall',
		'Schwedt/Oder',
		'Schweinfurt',
		'Schwerin',
		'Schwerte',
		'Seeheim-Jugenheim',
		'Siegen',
		'Sindelfingen',
		'Sliesthorp',
		'Smalkalda',
		'Solingen',
		'Spaichingen',
		'Spandau',
		'Spenge',
		'Speyer',
		'Springe',
		'Sprockhövel',
		'Stadt Crailsheim',
		'Stadt Neumarkt in der Oberpfalz',
		'Stadt Zwickau',
		'Stadtgemeinde Bremerhaven',
		'Stuttgart',
		'Stuttgart-Ost',
		'Syke',
		'Tempelhof',
		'Thomas-Müntzer-Stadt-Mühlhausen',
		'Throtmenni',
		'Treptow',
		'Tréveris',
		'Troisdorf',
		'Tubinga',
		'Tuttlingen',
		'Twistringen',
		'Two Bridges',
		'Übach-Palenberg',
		'Überherrn',
		'Überlingen',
		'Ubstadt-Weiher',
		'Ueckermünde',
		'Uelzen',
		'Uerdingen',
		'Uetersen',
		'Uhingen',
		'Uisibada',
		'Ulm',
		'Unna',
		'Unterfohring',
		'Unterhaching',
		'Unterkrozingen',
		'Unterschleissheim',
		'Urach',
		'Usingen',
		'Uslar',
		'Ütersen',
		'Vaihingen an der Enz',
		'Velbert',
		'Verwaltungsbezirk Friedrichshain',
		'Verwaltungsbezirk Köpenick',
		'Viersen',
		'Villingen-Schwenningen',
		'Vlotho',
		'Vreden',
		'Waiblingen',
		'Warendorf',
		'Wedding',
		'Weiden',
		'Weil am Rhein',
		'Weilheim in Oberbayern',
		'Weimar',
		'Weinheim',
		'Weissensee',
		'Werle',
		'Wermelskirchen',
		'Wernigerode',
		'Wesel',
		'Wesseling',
		'Wetter (Ruhr)',
		'Wetzlar',
		'Wiesbaden',
		'Wilhelmsburg',
		'Wilhelmshaven',
		'Wilhelmstadt',
		'Willich',
		'Wilmersdorf',
		'Winterhude',
		'Wismar',
		'Witten',
		'Wolfenbüttel',
		'Wolfsburgo',
		'Worms',
		'Wörth am Rhein',
		'Wuelfrath',
		'Wunsiedel',
		'Wunstorf',
		'Wuppertal',
		'Würselen',
		'Wurzburgo',
		'Wurzen',
		'Xanten',
		'Zehlendorf',
		'Zeitz',
		'Zerbst',
		'Zirndorf',
		'Zittau',
		'Zossen',
		'Zschopau',
		'Zulpich',
		'Zweibrücken',
		'Zwickau',
		'Zwiesel',
		'Zwönitz'
	],
	Andorra: ['Andorra la Vella', 'Encamp', 'Escaldes-Engordany'],
	'Arabia Saudí': [
		'Afif',
		'Al Ājām',
		'Al Aqīq',
		'Al Awjām',
		'Al Awwāmīyah',
		'Al Qaţīf',
		'Al-`Ula',
		'Aynayn',
		'Az Zilfī',
		'Dhaba',
		'Dhahran',
		'Djāzān',
		'Djidda',
		'Ebha',
		'Jiddah',
		'Jizan',
		'Mahd adh Dhahab',
		'Qalat Bīshah',
		'Riad',
		'Sūq al Ithnayn',
		'Umluj',
		'Umm ad Damār',
		'Umm as Sāhik',
		'Yidda',
		'Zbe'
	],
	Armenia: [
		'Ashtarakats Gyugh',
		'Ayrivan',
		'Dzhelaloglu',
		'Echmiadzin',
		'Edjmiatsín',
		'Eireaván',
		'Ereván',
		'Ghapan',
		'Gharakilisa',
		'Gyumri',
		'Hrazdan',
		'Idzhevan',
		'Iejmiatsin',
		'Ijevan',
		'Iravan',
		'Kyavar',
		'Kyumri',
		'Oktemberyan',
		'Revan',
		'Ssewan',
		'Üçkilise',
		'Ulukhanlu',
		'Yerevan'
	],
	Austria: [
		'Brigittenau',
		'Celovec',
		'Döbling',
		'Donaustadt',
		'Dornbirn',
		'Eggenberg',
		'Favoriten',
		'Feldkirch',
		'Floridsdorf',
		'Fünfhaus',
		'Gmunden',
		'Graz',
		'Hernals',
		'Hietzing',
		'Hütteldorf',
		'Imst',
		'Inner City',
		'Innsbruck',
		'Jakomini',
		'Josefstadt',
		'Klagenfurt',
		'Klagenfurt am Wörthersee',
		'Klosterneuburg',
		'Knittelfeld',
		'Landstraße',
		'Linz',
		'Meidling',
		'Ottakring',
		'Penzing',
		'Salzburgo',
		'Sievering',
		'Simmering',
		'Šmartin pri Celovcu- Otoče',
		'Spittal an der Drau',
		'Untergänserndorf',
		'Viena',
		'Währing',
		'Wiener Neustadt',
		'XII St. Martin'
	],
	Azerbaiyán: [
		'Ahmedbeyli',
		'Aja Kabul',
		'Bakú',
		'Dzhalilabad',
		'Emishti',
		'Gyandzha',
		'Imeni "Dvadtsati Shesti"',
		'Imeni Kaganovicha',
		'Imishli',
		'Jdanov',
		'Jsmailly',
		'Kasum-Izmaylovo',
		'Kjurdamir',
		'Kyurdarmir',
		'Nucha',
		'Nuxa',
		'Qaraçuxur',
		'Qobustan',
		'Ssabirabad',
		'Ssaljany',
		'Ucar',
		'Udzhar',
		'Ujar',
		'Xaçmaz',
		'Xankǝndi',
		'Xanlar',
		'Xirdalan',
		'Xudat',
		'Zyrya'
	],
	Bélgica: [
		'Aalst',
		'Aalter',
		'Aarlen',
		'Aarschot',
		'Aartselaar',
		'Aat',
		'Aeltre',
		'Aerschot',
		'Aertselaer',
		'Aiseau-Presles (Aiseau)',
		'Amberes',
		'An Bhruiséil',
		'Anderlecht',
		'Antwerp',
		'Antwerpen (Ekeren)',
		'Asse',
		'Ath',
		'Audenaarde',
		'Auderghem',
		'Aywaille',
		'Berchem-Sainte-Agathe',
		'Beveren-Waes',
		'Blankenberge',
		'Blauwput',
		'Brujas',
		'Bruselas',
		'Brussel·les',
		'Charleroi',
		'Charleroi (Gilly)',
		'Charleroi (Jumet)',
		'City of Brussels',
		'Deurne',
		'Doornyk',
		'Edegem',
		'Edingen',
		'Eeckeren',
		'Eeklo',
		'Éghezée',
		'Etterbeek',
		'Eupen',
		'Evere',
		'Evergem',
		'Eysden',
		'Flémalle (Flémalle-Grande)',
		'Flémalle (Flémalle-Haute)',
		'Fléron',
		'Fleurus',
		'Florennes',
		'Forest',
		'Furnes',
		'Gante',
		'Genk',
		'Gent',
		'Gheel',
		'Ghent',
		'Ghistelles',
		'Grâce-Hollogne (Hollogne-aux-Pierres)',
		'Hasselt',
		'Heist-aan-Zee',
		'Heusden-Zolder (Heusden)',
		'Heusden-Zolder (Zolder)',
		'Houthalen-Helchteren (Helchteren)',
		'Houthalen-Helchteren (Houthalen)',
		'Huy',
		'Ichtegem',
		'Ieper',
		'Iper',
		'Iseghem',
		'Ixelles',
		'Ixelles-Elsene',
		'Izegem',
		'Jembloux',
		'Jette',
		'Jodoigne',
		'Knokke',
		'Knokke-aan-Zee',
		'Knokke-Heist',
		'La Louvière',
		'Leuven',
		'Lieja',
		'Lovaina',
		'Luik',
		'Mechelen',
		'Mechelen-aan-de-Maas',
		'Molenbeek-Saint-Jean',
		'Mons',
		'Namur',
		'Nylen',
		'Oostende',
		'Oosterzele',
		'Oostkamp',
		'Opwijk',
		'Ostende',
		'Ottignies-Louvain-la-Neuve (Louvain-la-Neuve)',
		'Oudenaarde',
		'Oudergem',
		'Oud-Heverlee',
		'Oud-Turnhout',
		'Ougrêye',
		'Oupeye',
		'Overijse',
		'Overpelt',
		'Petegem-aan-de-Leie',
		'Quaregnon',
		'Rebecq (Rebecq-Rognon)',
		'Russelaers',
		'Ryckevorsel',
		'Saint-Ghislain',
		'Saint-Gilles',
		'Saint-Josse-ten-Noode',
		'Schaarbeek',
		'Schoten',
		'Sint-Amandsberg',
		'Sint-Gillis-Obbrussel',
		'Sint-Jans-Molenbeek',
		'Sint-Lambrechts-Woluwe',
		'Sint-Niklaas',
		'Sprimont',
		'Steen-Ockerzeel',
		'Sweveghem',
		'Termonde',
		'Tienen',
		'Tournai',
		'Turnhout',
		'Uccle',
		'Ukkel',
		'Verviers',
		'Vorst',
		'Wevelgem',
		'Wezembeek-Oppem',
		'Wilryck',
		'Woluwe-Saint-Lambert',
		'Wuustwezel',
		'Wynghene',
		'Ypres',
		'Yseghem',
		'Zedelgem',
		'Zele',
		'Zemst',
		'Zinnik',
		'Zonhoven',
		'Zonnebeke',
		'Zottegem',
		'Zulte',
		'Zwevegem',
		'Zwijndrecht',
	],
	Bielorrusia: [
		'Asipovichy',
		'Babruysk',
		'Baranovichi',
		'Barysaw',
		'Bobruysk',
		'Borisov',
		'Brest',
		'Brest-Litovsk',
		'Brześć nad Bugiem',
		'Byaroza',
		'Byarozawka',
		'Byelaazyorsk',
		'Byerastsye',
		'Byerazino',
		'Bykhaw',
		'Dzyarzhynsk',
		'Folvark Ivatseviche',
		'Gardinas',
		'Glubokoye',
		'Gómel',
		'Goradnia',
		'Gorod Zhodino',
		'Grodno',
		'Hlybokaye',
		'Homyel',
		'Horad Barysaw',
		'Horad Zhodzina',
		'Hrodna',
		'Ivanava',
		'Ivatsevichy',
		'Iwacewicze',
		'Jitkovichi',
		'Klimavichy',
		'Lida',
		'Lyda',
		"Lyepyel'",
		'Maguilov',
		"Mar''ina Horka",
		'Minsk',
		'Mogilev',
		'Molodechno',
		'Mozyr',
		'Mscislau',
		'Myensk',
		'Myory',
		'Navapolatsk',
		'Novopolotsk',
		'Nyasvizh',
		'Orsha',
		'Osipovichi',
		'Pinsk',
		'Pólatsk',
		'Polotskiy',
		'Pyetrykaw',
		'Rechytsa',
		'Ryechitsa',
		'Shatilki',
		'Slonim',
		'Slutsk',
		'Smalyavichy',
		"Smarhon'",
		'Soligorsk',
		'Svyetlahorsk',
		'Twacewicze',
		'Vítebsk',
		'Volkovysk',
		'Witebsk',
		'Wołkowysk',
		'Zhabinka',
		'Zhlobin',
		'Zhodzina',
		'Zhytkavichy',
		'Zlobin',
		'Žytkavičy',
	],
	'Bosnia y Herzegovina': [
		'Bania Luka',
		'Bihać',
		'Bosna-Sarai',
		'Donja Tuzla',
		'Krupa na Uni',
		'Lukavac Muslimanski',
		'Mostar',
		'Mrkonjić Grad',
		'Odžak',
		'Sarajevo',
		'Soli',
		'Srbinje',
		'Tuzla',
		'Velika Kladuša',
		'Vrh Bosna',
		'Vukosavlje',
		'Zenica',
		'Živinice',
	],
	Bulgaria: [
		'Ahiolo',
		'Aitos',
		'Ajtos',
		'Asenovgrad',
		'Asparukhovo',
		'Aytos',
		'Bjela Slatina',
		'Blagoevgrad',
		'Burgas',
		'Byala Slatina',
		'Cherveni-Bjerg',
		'Dimitrovo',
		'Dobrich',
		'Dristra',
		'Dupnitsa',
		'Dzhembek Makhala',
		'Džuma',
		'Eni Zagra',
		'Eski Djoumaïa',
		'Eski Dschumaja',
		'Eski Džuma',
		'Eski Zagra',
		'Etropole',
		'Eumolpias',
		'Exrdzhali',
		'Ferdinand',
		'Filiba',
		'Flavia',
		'Gabrovo',
		'Golyama Kutlovitsa',
		'Gorna Djoumaia',
		'Gorna Dshumaja',
		'Gorna Oryakhovitsa',
		'Hadži Ejles',
		'Hadži-Jeiles',
		'Hadži-Oghlu-Pazardžik',
		'Hadži-Oghlu-Pazardžik',
		'Iambol',
		'Ichtiman',
		'Ienizagra',
		'Ihtiman',
		'Ikhtiman',
		'Islimje',
		'Jambol',
		'Jeni Zagra',
		'Julia',
		'Khadzhi Eiles',
		'Khadzhioglu Bazardzhik',
		'Khaskovo',
		'Khristo Mikhaylov',
		'Kirdžali',
		'Kjustendil',
		'Krdjali',
		'Kŭrdzhali',
		'Küstendil',
		'Kyakyrdzhali',
		'Kyustendil',
		'Odessos',
		'Otalkiöj',
		'Pernik',
		'Philippopoli',
		'Pinople',
		'Pleven',
		'Plovdiv',
		'Poulpoudeva',
		'Rousse',
		'Ruse',
		'Saray-Makhle',
		'Schumen',
		'Shumen',
		'Sinople',
		'Sliven',
		'Slivengrad',
		'Smolyan',
		'Sofía',
		'Sredets',
		'Stalin',
		'Stara Zagora',
		'Šumen',
		'Sveti Vrač',
		'Svilengrad',
		'Svishtov',
		'Sweti Wratsch',
		'Swilengrad',
		'Swischtow',
		'Tatar Pazardzhik',
		'Tcherven Bryag',
		'Tchirpan',
		'Ternovo',
		'Tirnovo',
		'Tolbuhin',
		'Trimontium',
		'Trnovo',
		'Tschirpan',
		'Tŭrgovishte',
		'Tŭrnovo',
		'Ulpia',
		'Varna',
		'Velika Kutlovica',
		'Veliko Tarnovo',
		'Vinipoppolis',
		'Vratsa',
		'Warna',
		'Widin',
		'Wraza',
		'Xanne Sandanski',
		'Yambol',
	],
	Catar: [
		'Ad Dawḩa',
		'Dawḩat al Qaţar',
		'Doha',
		'Muaydhir Rawḑat Rāshid',
		'Umm Ghuwaylīnah',
		'Umm Lakhbā',
		'Umm Şalāl Muḩammad',
	],
	Chequia: [
		'Aebura',
		'Auszig',
		'Azbreh',
		'Berno',
		'Blansko',
		'Brno',
		'Čbán',
		'Česká Lípa',
		'České Budějovice',
		'Dvŭr Králové',
		'Faiknov',
		'Frýdek-Místek',
		'Fryštát',
		'Gradets Kralove',
		'Havířov',
		'Hlinsko',
		'Hlučín',
		'Hradec Králové',
		'Hranice',
		'Igława',
		'Jablonec nad Nisou',
		'Jičín',
		'Jihlava',
		'Jindřichův Hradec',
		'Jirkov',
		'Kladno',
		'Klášterec nad Ohří',
		'Klatovy',
		'Klösterle an der Eger',
		'Kralupy nad Vltavou',
		'Kvítkovice',
		'Kyjov',
		'Liberec',
		'Město Žďár a Zámek Žďár',
		'Mladá Boleslav',
		'Most',
		'Nový Jičín',
		'Nymburk',
		'Ober Počernitz',
		'Oderberg',
		'Olomouc',
		'Opava',
		'Orłowa',
		'Ostrava',
		'Ostrov nad Ohří',
		'Otrokovice',
		'Pardubice',
		'Pilsen',
		'Praga',
		'Přerov',
		'Prostějov',
		'Rychnov nad Kněžnou',
		'Sokolov nad Ohří',
		'Svitavy',
		'Teplice',
		'Třebíč',
		'Uherské Hradiště',
		'Uherský Brod',
		'Uničov',
		'Ústí nad Labem',
		'Ústin Orl',
		'Vlašim',
		'Vrchlabí',
		'Vsetín',
		'Vyskoe Myto',
		'Vyškov',
		'Vysočany',
		'Vysoké Mýto',
		'Wlaschim',
		'Wsetin',
		'Wysočan',
		'Žižkov',
		'Zlín',
		'Znojmo',
	],
	Chipre: ['Ayios Dhometios', 'Dhali', 'Égkomi', 'Idalion', 'Kyrenia', 'Nicosia', 'Nicosia (Lefkosia)', 'Omorfo'],
	Croacia: [
		'Andautonia',
		'Aqua Viva',
		'Bjelovar',
		'Centar',
		'Csáktornya',
		'Djakovo',
		'Dubrovnik',
		'Eszek',
		'Mursia',
		'Osijek',
		'Pluj',
		'Pula',
		'Rijeka',
		'Ságrab',
		'Slavonski Brod',
		'Split',
		'Sziszek',
		'Vukovar',
		'Warasdin',
		'Zadar',
		'Zagreb',
	],
	Dinamarca: [
		'Aabenraa',
		'Aalborg',
		'Aarhus',
		'Abenrá',
		'Ålborg',
		'Århus',
		'Avedøre',
		'Ballerup',
		'Copenhague',
		'Elsinor',
		'Esbjerg',
		'Fladstrand',
		'Fløng',
		'Fredericia',
		'Frederiksberg',
		'Gjellerup',
		'Glostrup',
		'Herning',
		'Hillerød',
		'Hjørring',
		'Horsens',
		'Hørsholm',
		'Hvidovre',
		'Ikast',
		'Ishøj',
		'Jyllinge',
		'Kgs. Lyngby',
		'Kjobenhavn',
		'Kjoge',
		'Klinteby Frihed',
		'Kobenhavn',
		'Municipi dAlbertslund',
		'Nyborg',
		'Nykøbing F',
		'Odder',
		'Odense',
		'Randers',
		'Rødovre',
		'Skive',
		'Slagelse',
		'Svendborg',
		'Vejle',
	],
	'Emiratos Árabes Unidos': [
		'Abu Dabi',
		'Abu Dhabi',
		'Abu Dhabi Island and Internal Islands',
		'Abū Z̧abī',
		'Adh Dhayd',
		'Ajman',
		'Al Ayn',
		'Ghālla',
		'Ihaid',
		'Jimeirah',
		'Knowledge Village',
		'Ujman',
		'Umm al Qawain',
		'Umm Al Quwain',
		'Xarjah',
	],
	Eslovaquia: [
		'An Bhratasláiv',
		'Banská Bystrica',
		'Bratislava',
		'Brezno nad Hronom',
		'Bytča',
		'Csacza',
		'Czaca',
		'Duna-Szerdahely',
		'Eperjes',
		'Érsekújvár',
		'Hlohovec',
		'Humenné',
		'Igló',
		'Kassa',
		'Košice',
		'Kysucké Nové Mesto',
		'Liptovský Svätý Mikuláš',
		'Myjava',
		'Nagyszombat',
		'Nitra',
		'Nové Zámky',
		'Nyitra',
		'Old Town',
		'Považská Bystrica',
		'Presburg',
		'Prešov',
		'Prievidza',
		'Rima-Szombat',
		'Ružomberok',
		'Snina',
		'Spišská Nová Ves',
		'Svätý Kríž nad Hronom',
		'Svidník',
		'Trenčín',
		'Trnava',
		'Turčiansky Svätý Martin',
		'Tyrnau',
		'Uyvar',
		'Vranov nad Topľou',
		'Vyšnyj Svidnik',
		'Waagbistritz',
		'Žiar nad Hronom',
		'Žilina',
		'Zlaté Moravce',
		'Zólyom',
		'Zsolna',
		'Zvolen',
		'Żylina',
	],
	Eslovenia: ['Celje', 'Cragni', 'Izola', 'Liubliana', 'Ljubljana', 'Lubliano', 'Oisnitz', 'Ptuj', "Tsel'e"],
	España: [
		'Abarán',
		'Abrantes',
		'Acacias',
		'Adelfas',
		'Adra',
		'Aguilar de la Frontera',
		'Águilas',
		'Al Jezita',
		'Albacete',
		'Alcalá de Guadaíra',
		'Alcalá de Henares',
		'Alcázar de San Juan',
		'Alcobendas',
		'Alcorcón',
		'Algeciras',
		'Algorta',
		'Alicante',
		'Almería',
		'Amorebieta-Echano',
		'Amposta',
		'Amurrio',
		'Antequera',
		'Aorroyomolinos',
		'Apostol Santiago',
		'Aranda de Duero',
		'Aranjuez',
		'Arganda del Rey',
		'Aspe',
		'Atamaría',
		'Atarfe',
		'Atarrabia',
		'Ávila',
		'Avilés',
		'Ayamonte',
		'Azcoitia',
		'Azpeitia',
		'Azuqueca',
		'Badajoz',
		'Badalona',
		'Barcelona',
		'Barri de Sant Andreu',
		'Barriada de Aguadulce',
		'Barrio Ciudad Lineal',
		'Barrio El Clot',
		'Barrio el Raval',
		'Barrio Moratalaz',
		'Barrio Obrero Las Matas',
		'Barrio Puente de Vallecas',
		'Bilbao',
		'Blanes',
		'Burgos',
		'Cádiz',
		'Caesaraugusta',
		'Caesarea Augusta',
		'Cardoue',
		'Caronium',
		'Cartagena',
		'Casco Histórico de Vallecas',
		'Casco Histórico de Vicálvaro',
		'Castelló de la Plana',
		"Castelló d'Empúries",
		'Castilleja de la Cuesta',
		'Castro-Urdiales',
		'Cerdanyola del Vallès',
		'Ceuta',
		'Chamartín',
		'Chamartín de la Rosa',
		'Chiclana de la Frontera',
		'Ciudad Lineal',
		'Ciudad Real',
		'Ciudad Universitaria',
		'Ciutat de Mallorca',
		'Ciutat de Múrcia',
		'Collado Villalba',
		'Cómpluto',
		'Corbera de Llobregat',
		'Córdoba',
		'Coria del Río',
		'Cornellà de Llobregat',
		'Coslada',
		'Crevillente',
		'Cuart de Poblet',
		'Cubelles',
		'Cuenca',
		'Cullera',
		'Culleredo',
		'Delicias',
		'Distrito Arganzuela',
		'Distrito Carabanchel',
		'Distrito Chamartín',
		'Distrito Chamberí',
		'Distrito de Ciutat Vella',
		'Distrito de Gracia',
		'Distrito de Horta-Guinardó',
		'Distrito de Sants-Montjuïc',
		'Distrito del Ensanche',
		'Distrito Latina',
		'Distrito Les Corts',
		'Distrito Nou Barris',
		'Distrito Retiro',
		'Distrito Salamanca',
		'Distrito San Blas-Canillejas',
		'Distrito Sant Andreu',
		'Distrito Sarrià-Sant Gervasi',
		'Distrito Usera',
		'Donostia / San Sebastian',
		'Dos Hermanas',
		"Dreta de l'Eixample",
		'Durango',
		'Écija',
		'Egea de los Caballeros',
		'Ehibar',
		'Eibar',
		'Eivissa',
		'Eixample',
		'Eixample de Barcelona',
		'Eixea',
		'Ejea',
		'El Bocho',
		"el Camp de l'Arpa del Clot",
		'El Ejido',
		'el Guinardó',
		'el Parc i la Llacuna del Poblenou',
		'El Pilar de la Foradada',
		'El Prat de Llobregat',
		'el Putxet i el Farró',
		'Elche',
		'Elda',
		'Embajadores',
		'Entrevías',
		'Errenteria',
		'Esplugues de Llobregat',
		'Estación de Cuatro Caminos',
		'Estepona',
		'Eybar',
		'Felanitx',
		'Ferrol',
		'Figueres',
		'Fort Pienc',
		'Fuencarral',
		'Fuencarral-El Pardo',
		'Fuengirola',
		'Fuenlabrada',
		'Fuensalida',
		'Fuente del Berro',
		'Fuente Palmera',
		'Fuenterrabía',
		'Gadir',
		'Gamonal',
		'Gamonal de Ríopico',
		'Gandía',
		'Gavà',
		'Gerona',
		'Getafe',
		'Getxo',
		'Gijón',
		'Gijón/Xixón',
		'Girona',
		'Gothic Quarter',
		'Gràcia',
		'Granada',
		'Granollers',
		'Grao de Murviedro',
		'Guadalajara',
		'Guia de Izara',
		'Guindalera',
		'Hispalis',
		'Hispanoamérica',
		'Hortaleza',
		'Hospitalet de Llobregat',
		'Huelva',
		'Huércal Overa',
		'Huesca',
		'Ibi',
		'Ibiza',
		'Ibiza',
		'Icod de los Vinos',
		'Iecla',
		'Igualada',
		'Illescas',
		'Illora',
		'Imperial',
		'Inca',
		'Irún',
		'Irún-Uranzu',
		'Isla Cristina',
		'Iturrama',
		'Jaén',
		'Jarez de la Frontera',
		'Játiva',
		'Jávea',
		'Jerez de la Frontera',
		'Jerez de los Caballeros',
		'Jimena de la Frontera',
		'Jódar',
		'Jrobe',
		'Jumilla',
		'Justicia',
		'La Bella Easo',
		'La Bisbal del Ampurdán',
		"la Bisbal d'Empordà",
		'La Coruña',
		'La Eliana',
		'La Llagosta',
		"la Nova Esquerra de l'Eixample",
		'la Nucia',
		'La Química',
		'La Rinconada',
		"la Seu d'Urgell",
		'La tacita de plata',
		'La Unión',
		'La Vila Joiosa',
		'la villa jarrillera',
		'La Zubia',
		'Langreo',
		"l'Antiga Esquerra de l'Eixample",
		'Las Águilas',
		'Las Cabezas de San Juan',
		'Las Rozas de Madrid',
		'Leganés',
		'León',
		'Lérida',
		'Les Corts',
		'Llanera',
		'Llanes',
		'Llefià',
		'Lleida',
		'Lleó',
		'Llíria',
		'Llissá de Munt',
		'Llodio',
		'Llorca',
		'Lloret de Mar',
		'Llucmajor',
		'Llugones',
		'Logroño',
		'Lorca',
		'Lugo',
		'Madrid',
		'Madrid Centro',
		'Madrid City Center',
		'Málaga',
		'Mérida',
		'Mieres del Camino',
		'Mijas',
		'Miranda de Ebro',
		'Mislata',
		'Moncloa-Aravaca',
		'Móstoles',
		'Murcia',
		'Nueva España',
		'Nules',
		'Numancia',
		'Ogíjares',
		'Oleiros',
		'Olesa de Montserrat',
		'Oliva',
		'Oliver-Valdefierro',
		'Olot',
		'Onda',
		'Onteniente',
		'Oñate',
		'Opañel',
		'Orense',
		'Orihuela',
		'Osca',
		'Ourense',
		'Oviedo',
		'Palencia',
		'Palma de Mallorca',
		'Pamplona',
		'Parla',
		'Pilar',
		'Pinar del Rey',
		'Pincia',
		'Pinto',
		'Plasencia',
		'Pozuelo de Alarcón',
		'Primer Ensanche',
		'Primer Ensanche',
		'Prosperidad',
		'Pto. de Sta. María',
		'Pucela',
		'Puebla de Vallbona',
		'Pueblo Nuevo',
		'Puente de Vallecas',
		'Puente-Genil',
		'Puerta Bonita',
		'Puerta del Angel',
		'Puerto de Santa María',
		'Puerto Real',
		'Puertollano',
		'Punta Umbría',
		'Puzol',
		'Quadix',
		'Quart de Poblet',
		'Quintana',
		'Quintanar de la Orden',
		'Reus',
		'Ripollet',
		'Rivas Vaciamadrid',
		'Roquetas de Mar',
		'Rubí',
		'Sabadell',
		'Sagrada Família',
		'Salamanca',
		'San Agustín del Guadalix',
		'San Antonio Abad',
		'San Blas-Canillejas',
		'San Cucufate',
		'San Feliú de Llobregat',
		'San Fernando',
		'San Fernando de Henares',
		'San Isidro',
		'San Javier',
		'San Juan',
		'San Juan de Alicante',
		'San Juan de Aznalfarache',
		'San Julian',
		'San Pedro de Ribas',
		'San Quirico de Tarrasa',
		'San Sebastián',
		'San Sebastián de los Reyes',
		'San Sebastián de los Reyes',
		'San Vicente de Baracaldo',
		'San Vicente del Raspeig',
		'Sant Adrià de Besòs',
		'Sant Agustí',
		'Sant Andreu',
		'Sant Andreu de Palomar',
		'Sant Boi de Llobregat',
		'Sant Cugat',
		'Sant Cugat del Vallès',
		'Sant Feliu de Guíxols',
		'Sant Feliu de Guíxols',
		'Sant Gervasi - Galvany',
		"Sant Joan d'Alacant",
		'Sant Joan Despí',
		'Sant Just Desvern',
		'Santa Coloma de Gramenet',
		'Santa Eugenia',
		'Santa Eugenia de Ribeira',
		'Santa Eulalia del Río',
		'Santa Uxía de Ribeira',
		'Santander',
		'Santiago de Compostela',
		'Santurce-Antiguo',
		'Saragossa',
		'Sarrià-Sant Gervasi',
		'Segundo Ensanche',
		'Segundo Ensanche',
		'Sevilla',
		'Siviglia',
		'Sunlucar de Barrameda',
		'Talavera de la Reina',
		'Talavera del Tajo',
		'Tarragona',
		'Terrassa',
		'Tetuán',
		'Tetuán de las Victorias',
		'The Groyne',
		'Toledo',
		'Torrejón de Ardoz',
		'Torrelavega',
		'Torremolinos',
		'Torrente',
		'Torrevieja',
		'Tudela',
		'Úbeda',
		'Ubrique',
		'Unci',
		'Universidad',
		'Utebo',
		'Utiel',
		'Utrera',
		'Valdefuentes',
		'Valencia',
		'Valladolid',
		'Valverde',
		'Vélez-Málaga',
		'Ventas',
		'Vigo',
		'Vila de Gràcia',
		'Vilanova i la Geltrú',
		'Vilapicina i la Torre Llobeta',
		'Vila-real',
		'Villa de Vallecas',
		'Villa-Real',
		'Villarrubia de los Ojos',
		'Villaverde',
		'Villaviciosa de Odón',
		'Vitoria',
		'Vitoria-Gasteiz',
		'Xàbia',
		'Xàtiva',
		'Xinzo',
		'Xirivella',
		'Xiva de Bunyol',
		'Yaldepenas',
		'Yecla',
		'Zamora',
		'Zaragoza',
		'Zizur Mayor',
		'Zofío',
		'Zumárraga',
	],
	Estonia: [
		'Derpt',
		'Ievve',
		'Iohvi',
		'Iykhvi',
		'Jõhvi',
		'Kallinn',
		'Kohtla-Järve',
		'Kokhtla-Yarve',
		'Kolyvan',
		'Narva',
		'Nymme',
		"Revel'",
		'Tallin',
		'Tartu',
		'Tērbata',
		'Türpsal',
		'Tyurpsal',
		'Vylandė',
		'Vyru',
		'Yokhvi',
		'Yykhvi',
	],
	Finlandia: [
		'Äänekoski',
		'East Helsinki',
		'Ekenäs',
		'Espoo',
		'Gamla-Karlabyu',
		'Helsinki',
		'Hyvinkää',
		'Idensalmi',
		'Iisalmi',
		'Ilmajoki',
		'Imatra',
		"Isal'mi",
		'Järvenpää',
		'Joensuu',
		'Jyväskylä',
		'Kaukha-Yoki',
		'Khamenlinna',
		'Kjana',
		'Klaukkala',
		'Knyaani',
		'Kuopio',
		'Lahti',
		'Lappeenranta',
		'Mikkeli',
		'Nurmijärvi',
		'Nyustad',
		'Oulu',
		'Pori',
		'Rauma',
		'Rovaniemi',
		'Ruotsinsalmi',
		'Svensksund',
		'Tampere',
		'Thusby',
		'Turku',
		'Tuusula',
		'Uleoborg',
		'Ulvila',
		'Usikaupunki',
		'Uusikaupunki',
		'Vaasa',
		'Vantaa',
		'Villmanstrand',
		'Vuosaari',
		'Ylivieska',
		'Ylöjärvi',
		'Yoensu',
	],
	Francia: [
		'Abbeville',
		'Achères',
		'Agde',
		'Agén',
		'Aiacciu',
		'Aire-sur-la-Lys',
		'Aisinas',
		'Aix-en-Provence',
		'Aix-les-Bains',
		'Ajaccio',
		'Amiens',
		'An Oriant',
		'Angers',
		'Angulema',
		'Annecy',
		'Antibes',
		'Antony',
		'Apt',
		'Aquae Sextiae',
		'Ar Baol-Skoubleg',
		'Argenteuil',
		'Arlés',
		'Arles-sur-Rhône',
		'Arles-Trinquetaille',
		'Arrás',
		'Asnières',
		'Asnières-sur-Seine',
		'Athis-Mons',
		'Aubagne',
		'Aubagne en Provence',
		'Aubervilliers',
		'Auch',
		'Aulnay-sous-Bois',
		'Aulnay-sous-Bois',
		'Aurenja',
		'Aurillac',
		'Auxerre',
		'Aviñón',
		'Avion',
		'Avon',
		'Avrillé',
		'Bel-Air',
		"Bernay-de-l'Eure",
		"Berre-l'Étang",
		'Besanzón',
		'Blagnac',
		'Blanquefort',
		'Blois',
		'Bordeaux',
		'Bouc-Bel-Air',
		'Boulogne-Billancourt',
		'Boulogne-sur-Seine',
		'Brest',
		'Brive-la-Gaillarde',
		'Burdeos',
		'Bures-sur-Yvette',
		'Caen',
		'Caluire-et-Cuire',
		'Cergy',
		'Cergy-Pontoise',
		'Champigny-sur-Marne',
		'Chaumont Enbassigby',
		'Cherburgo-Octeville',
		'Cinq Avenues',
		'Clamart',
		'Clarmont dAlvèrnia',
		'Clermont-Ferrand',
		'Clichy',
		'Clichy-sous-Bois',
		'Cluses',
		'Corbeil-Essonnes',
		"Cournon-d'Auvergne",
		'Creil',
		'Créteil',
		'Croix',
		'Cunhaus',
		'Cusset',
		'Dammarie-les-Lys',
		'Dijon',
		'Divodurum',
		'Douai',
		'Draguignan',
		'Drancy',
		'Draveil',
		'Dreux',
		'Dunkerque',
		'Eaubonne',
		'Échirolles',
		'Écully',
		'El Havre',
		'Élancourt',
		'Épernay',
		'Épinal',
		'Épinay-sous-Sénart',
		'Épinay-sur-Seine',
		'Équeurdreville-Hainneville',
		'Ermont',
		'Estrasburgo',
		'Étampes',
		'Étaples',
		'Évreux',
		'Évry',
		'Eybens',
		'Eysines',
		'Fécamp',
		'Felger',
		'Figeac',
		'Firminy',
		'Flers',
		'Fleury-les-Aubrais',
		'Floirac',
		'Florange',
		'Folie Méricourt',
		'Fontaine',
		'Fontainebleau',
		'Fontenay-aux-Roses',
		'Fontenay-le-Fleury',
		'Fontenay-sous-Bois',
		'Forbach',
		'Fort Châtillon',
		'Fréjus',
		'Gap',
		'Gare',
		'Garges-lès-Gonesse',
		'Gennevilliers',
		'Gif-sur-Yvette',
		'Grande-Synthe',
		'Grenoble',
		'Guyancourt',
		'Gwened',
		'Hérouville Saint-Clair',
		'Hyange',
		'Hyerès',
		'Ieras',
		'Illkirch-Graffenstaden',
		'Illzach',
		'Issy-les-Moulineaux',
		'Istres',
		'Ivry sobre Sena',
		'Joinville-le-Pont',
		'Joué-lès-Tours',
		'Jouy-le-Moutier',
		'Juvignac',
		'Juvisy-sur-Orge',
		'Kemper',
		'La Celle-Saint-Cloud',
		'La Crau',
		'La Flèche',
		'La Queue-en-Brie',
		'La Rochelle',
		'La Roche-sur-Yon',
		'La Roche-sur-Yon',
		'La Seyne-sur-Mer',
		'Laval',
		'Le Blanc-Mesnil',
		'Le Creusot',
		'Le Grand-Quevilly',
		'Le Mans',
		'Le Petit-Quevilly',
		'Le Plessis-Robinson',
		'Le Plessis-Trévise',
		'Les Clayes-sous-Bois',
		'Les Ulis',
		"L'Illa de Sòrga",
		'Lille',
		'Limoges',
		'Lió',
		"L'Isle-Adam",
		'Livry-en-Aulnoye',
		'Llemotges',
		'Lorient',
		"L'Union",
		'Lyon',
		'Lyon 01',
		'Lyon 02',
		'Lyon 03',
		'Lyon 04',
		'Lyon 05',
		'Lyon 06',
		'Lyon 07',
		'Lyon 08',
		'Lyon 09',
		'Maison Blanche',
		'Mantes-Gassicourt',
		'Mantes-la-Jolie',
		'Marne La Vallée',
		'Marsella',
		'Mérignac',
		'Metz',
		'Moissy-Cramayel',
		'Montereau-Fault-Yonne',
		'Montpellier',
		'Montreuil',
		'Montreuil-sous-Bois',
		'Mont-Saint-Aignan',
		'Mulhouse',
		'Nancy',
		'Nanterre',
		'Nantes',
		'Narbona',
		'Neuilly-sur-Seine',
		'Nimes',
		'Niort',
		'Niza',
		'Nogent-sur-Oise',
		'Noisy-le-Grand',
		'Nyon',
		'Obernai',
		'Octeville',
		'Oignies',
		'Oissel',
		'Orange',
		'Orleans',
		'Orlhac',
		'Oullins',
		'Outreau',
		'Oyonnax',
		'Ozoir-la-Ferrière',
		'Ozoir-la-Ferrière',
		'París',
		'Paris 10e Arrondissement',
		'Paris 11e Arrondissement',
		'Paris 12e Arrondissement',
		'Paris 13e Arrondissement',
		'Pau',
		'Perpiñán',
		'Picpus',
		'Plaisir',
		'Ploemeur',
		'Poitiers',
		'Puteaux',
		'Quimper',
		'Quimperlé',
		'Quinze-Vingts',
		'Reims',
		'Rennes',
		'Rheims',
		'Roazhon',
		'Romans-sur-Isère',
		'Roubaix',
		'Rouen',
		'Ruan',
		'Rueil-Malmaison',
		'Rumans',
		'Saint-Amand-les-Eaux',
		'Saint-Ambroise',
		'Saint-Avertin',
		'Saint-Avold',
		'Saint-Cloud',
		"Saint-Cyr-l'École",
		'Saint-Cyr-sur-Loire',
		'Saint-Cyr-sur-Mer',
		'Saint-Denis',
		'Sainte-Foy-lès-Lyon',
		'Saint-Étienne',
		'Saint-Étienne-du-Rouvray',
		'Saint-Germain-en-Laye',
		'Saint-Jean-de-Braye',
		'Saint-Jean-de-la-Ruelle',
		'Saint-Jean-de-Luz',
		'Saint-Junien',
		'Saint-Just-sur-Loire',
		'Saint-Maur-des-Fossés',
		'Saint-Maur-les-Fossés',
		'Saint-Médard-en-Jalles',
		'Saint-Nazaire',
		'Saint-Omer',
		'Saint-Ouen',
		"Saint-Ouen-l'Aumône",
		'Saint-Priest',
		'Saint-Quentin',
		'Saint-Quentin-en-Yvelines',
		'Salon-de-Provence',
		'San Egreve',
		'San Juan de Luz',
		'Sant Joan Lohitzune',
		'Sant-Ervlan',
		'Sarcelles-Lochère',
		'Savigny-sur-Orge',
		'Schiltigheim',
		'Sens-sur-Yonne',
		'Six Fours',
		'Six-Fours-les-Plages',
		'Strasbourg',
		'Tarbes',
		'Thionville',
		'Thonon-les-Bains',
		'Tolón',
		'Tolosa de Francia',
		'Tolosa de Llenguadoc',
		'Toulon-sur-Mer',
		'Toulouse',
		'Tourcoing',
		'Tours',
		'Troyes',
		'Uxellodunum',
		'Valence',
		'Vénissieux',
		'Versalles',
		"Ville-d'Avray",
		"Villeneuve-d'Ascq",
		'Villeneuve-lès-Avignon',
		'Villeurbanne',
		'Vitry-sur-Seine',
		'Wattrelos',
		'Yerres',
		'Yutz Haute',
		'Yvetot',
		'Yzeure',
	],
	Georgia: [
		'Achal Senaki',
		'Ajaltsije',
		"Akhalts'ikhe",
		"Bat'umi",
		'Dshugeli',
		'Dzhugeli',
		'Kvirily',
		'Lentekhi',
		'Micha-Zchakaja',
		"Och'amch'ire",
		'Ozurgueti',
		'Psirtskha',
		'Ssamtredia',
		'Ssuchum',
		'Stantsiya Akhali-Afoni',
		'Tbilisi',
		'Tiflis',
		'Tkibuli',
		'Tkuarchal',
		'Tpilisi',
		'Tqibuli',
		"Tqvarch'eli",
		'Tsqaltubo',
		'Zestaponi',
		"Zestap'oni",
		'Zygdidi',
	],
	Grecia: [
		'Acharnes',
		'Aegaleo',
		'Aegion',
		'Afini',
		'Aghios Nicolaos',
		'Agía Paraskeví',
		'Agía Varvára',
		'Ágioi Anárgyroi',
		'Agios Dimitrios',
		'Agios Ioannis Rentis',
		'Agrinio',
		'Aigáleo',
		'Aigio',
		'Aikateríni',
		'Akharnaí',
		'Alt Phaleron',
		'Amaliáda',
		'Amarousio',
		'An Aithin',
		'Aspropyrgos',
		'Atenas',
		'Ayía Paraskeví',
		'Ayía Varvára',
		'Áyios Athanásios',
		'Áyios Dhimítrios',
		'Áyios Konstandínos',
		'Áyios Nikólaos',
		'Áyios Yeóryios',
		'Càndia',
		'Cydonia',
		'Dhafní',
		'Dhiavatá',
		'Dhráma',
		'Drama',
		'Drapetsona',
		'Edessa',
		'Efkarpia',
		'Egaleo',
		'Egion',
		'El Pireo',
		'Elefsina',
		'Eleftherio-Kordelio',
		'Epakhtos',
		'Ērakleion',
		'Eskije',
		'Euripos',
		'Evkarpía',
		'Evosmos',
		'Florina',
		'Galatsi',
		'Giannitsá',
		'Glyfada',
		'Gümülcine',
		'Hagios Georgios Keratsiniou',
		'Heraklion',
		'Hios',
		'Ialysos',
		'Ierápetra',
		'Ílion',
		'Ilioúpoli',
		'Ioánina',
		'Iolcus',
		'Irákleion',
		'Iraklion',
		'Janina',
		'Kallithea',
		'Keratsini',
		'Khaïdhári',
		'Khalándrion',
		'Khalkís',
		'Khandax',
		'Khaniá',
		'Kifissia',
		'Kipoúpolis',
		'Kreta',
		'Lamia',
		'Larissa',
		'Megalokastron',
		'Menidi',
		'Mytilene',
		'Nea Coclutsa',
		'Néa Filadélfeia',
		'Nea Ionia',
		'Néa Ioniá',
		'Néa Ionía',
		'Néa Ionía',
		'Nea Liosia',
		'Néa Sfayía',
		'Néa Smýrni',
		'Neapolis',
		'Neo Psychiko',
		'Nikaia',
		'Oikismós Papágou',
		'Old Faliron',
		'Palaio Faliro',
		'Patrás',
		'Peiraeus',
		'Peristeri',
		'Ptolemaida',
		'Pylaia',
		'Pýrgos',
		'Quíos',
		'Rhodes',
		'Rhodes Town',
		'Salónica',
		'Selanik',
		'Solun',
		'Sparti',
		'Sykies',
		'Taousán Lófos',
		'Tebas',
		'Tesalónica',
		'Thebes',
		'Thessaloniki',
		'Trikala',
		'Týrnavos',
		'Vlikha',
		'Volos',
		'Vrilissia',
		'Výronas',
		'Xanthē',
		'Xíos',
		'Yannina',
		'Yenitsá',
		'Yiannitsá',
		'Yidhá',
		'Yirápetra',
		'Ymittos',
		'Zografos',
	],
	'Países Bajos': [
		'Aalsmeer',
		'Aalten',
		'Afraai',
		'Alkmaar',
		'Almelo',
		'Almere Stad',
		'Alphen aan den Rijn',
		'Alphen aan den Rijn',
		'Amersfoort',
		'Amstelveen',
		'Ámsterdam',
		'Amsterdam-Zuidoost',
		'Apeldoorn',
		'Appingedam',
		'Arnhem',
		'Assen',
		'Assendelft',
		'Bergen op Zoom',
		'Beuningen Gld',
		'Bloemhof',
		'Bolduque',
		'Breda',
		'Capelle aan den IJssel',
		'Cranendonck',
		'Culemborg',
		'De Jouwer',
		'Delft',
		'Den Helder',
		'Deventer',
		'Doetinchem',
		'Dordrecht',
		'Drachten',
		'Dronten',
		'Ede',
		'Eerbeek',
		'Eersel',
		'Eindhoven',
		'Eisden',
		'Emmeloord',
		'Emmen',
		'Enkhuizen',
		'Enschede',
		'Epe',
		'Eysden',
		'Flesinga',
		'Goes',
		'Gouda',
		'Groninga',
		'Groot IJsselmonde',
		'Guda',
		'Haarlem',
		'Heerlen',
		'Helmond',
		'Hendrik-Ido-Ambacht',
		'Hengelo',
		'Hertogenbosch',
		'Hillegom',
		'Hilversum',
		'Hoge Vucht',
		'Hoofddorp',
		'Hoogeveen',
		'Hoorn',
		'Huizen',
		'IJmond',
		'IJselstein',
		'Katijk aan Zee',
		'Katwijk aan Zee',
		'Kerkrade',
		'Klazienaveen',
		'Krimpen aan den IJssel',
		'La Haya',
		'Leeuwarden',
		'Leiden',
		'Lelystad',
		'Lieuwarden',
		'Ljouwert',
		'Middelburg',
		'Nieuwegein',
		'Nieuwer Amstel',
		'Nimega',
		'Nuenen',
		'Nunspeet',
		'Nymegen',
		'Oegstgeest',
		'Oirschot',
		'Oisterwijk',
		'Oldenzaal',
		'Ommen',
		'Ommoord',
		'Oorschot',
		'Oosterbeek',
		'Oosterhout',
		'Oosterpark',
		'Oosterwijk',
		'Opmeer',
		'Oss',
		'Oud Beierland',
		'Purmerend',
		'Pynakker',
		'Rhenen',
		'Rhoon',
		'Ridderkerk',
		'Rijswijk',
		'Roosendaal',
		'Rotterdam',
		'Schiedam',
		'Sint-Oedenrode',
		'Sliedrecht',
		'Sneek',
		'Spijkenisse',
		'Tiel',
		'Tilburgo',
		'Twello',
		'Uden',
		'Uitgeest',
		'Uithoorn',
		'Ulft',
		'Uriezenveen',
		'Urk',
		'Utrecht',
		'Veenendaal',
		'Velsen',
		'Velsen-Zuid',
		'Venlo',
		'Vlaardingen',
		'Vlissingen',
		'Vreewijk',
		'Vriezenveen',
		'Vught',
		'Waalwijk',
		'Wageningen',
		'Weert',
		'Wijchen',
		'Woerden',
		'Ymuiden',
		'Ypenburg',
		'Zaandam',
		'Zaanstad',
		'Zeist',
		'Zevenaar',
		'Zierikzee',
		'Zoetermeer',
		'Zutphen',
		'Zwijndrecht',
		'Zwolle',
	],
	Hungría: [
		'11th District of Budapest',
		'3rd District of Budapest',
		'Abony',
		'Ágostyán',
		'Ajka',
		'Angyalföld',
		'Budapest',
		'Budapest II. kerület',
		'Budapest III. kerület',
		'Budapest IV. kerület',
		'Budapest VIII. kerület',
		'Budapest XI. kerület',
		'Budapest XII. kerület',
		'Budapest XII. kerület',
		'Budapest XIII. kerület',
		'Budapest XIX. kerület',
		'Budapest XV. kerület',
		'Budapest XVI. kerület',
		'Budapest XVI. kerület',
		'Budapest XVII. kerület',
		'Budapest XVIII. kerület',
		'Budapest XX. kerület',
		'Budapest XXI. kerület',
		'Budapest XXII. kerület',
		'Budapest XXIII. kerület',
		'Bükkszentlászló',
		'Cegléd',
		'Center',
		'Csékút',
		'Csepel',
		'Csepel-Belváros',
		'Csepel-Királyerdő',
		'Csillagtelep',
		'Csongrád',
		'Csorna',
		'Czegled',
		'Czelldömölk',
		'Debrecen',
		'Dunakeszi',
		'Dunaújváros',
		'Edelény',
		'Eger',
		'Endrőd',
		'Érd',
		'Erzsébetfalva',
		'Erzsébetváros',
		'Fünfkirchen',
		'Gerla',
		'Gyál',
		'Gyomaendrőd',
		'Gyömrő',
		'Gyón',
		'Gyöngyös',
		'Győr',
		'Gyula',
		'Gyulafirátót',
		'Hadházytelep',
		'Hetény',
		'Hird',
		'Hodoscsépány',
		'Ipolyszög',
		'Izsákfa',
		'Jager',
		'Jászberény',
		'Józsa',
		'József Attila-lakótelep',
		'Józsefváros',
		'Kecskemét',
		'Kiskundorozsma',
		'Kispest',
		'Klein-Pest',
		'Középső-Ferencváros',
		'Málom',
		'Mecek Sabolc',
		'Mecsekalja',
		'Ménfőcsanak',
		'Mezőmegyer',
		'Miskolc',
		'Nadapipad',
		'Nadarpad',
		'Nagykanizsa',
		'Nagymajor',
		'Nyírbátor',
		'Nyírszőllős',
		'Nyírszőlős',
		'Óbuda-Békásmegyer',
		'Óhegy',
		'Ókécske',
		'Ond',
		'Orosháza',
		'Ózd',
		'Patacs',
		'Pécs',
		'Pinnyéd',
		'Quinque Ecclesiae',
		'Rácváros',
		'Rákoscsaba-Újtelep',
		'Seghedin',
		"Shalgo Tar'yan",
		'Somogy',
		'Szarvas',
		'Százhalombatta',
		'Szeged',
		'Székesfehérvár',
		'Szekszárd',
		'Szentendre',
		'Szentes',
		'Szentsimon',
		'Széphalom',
		'Szigetszentmiklós',
		'Szolnok',
		'Szombathely',
		'Szőny',
		'Tápé',
		'Tatabánya',
		'Terézváros',
		'Toponár',
		'Újbuda',
		'Újfehértó',
		'Újhegy',
		'Újhely',
		'Újkécske',
		'Újpéteritelep',
		'Újváros',
		'Üllő',
		'Uraj',
		'Üreghuta',
		'Üveghuta',
		'Vasas',
		'Veszprém',
		'Zalaegerszeg',
		'Zugló',
	],
	Irak: [
		'Abu Ghraib',
		'Afak',
		'Al Azīzīyah',
		'Al Başrah al Qadīmah',
		'Al Ibrāhīmīyah',
		'al-Ghadiriya',
		'Aora',
		'Aqrah',
		'Bagdad',
		'Bghailah',
		'Imam Qasim',
		'Irbil',
		'Kut al Imāra',
		'Omolgasr',
		'Qaḑā al Hindīyah',
		'Qaḑā al Kūfah',
		'Qarah Qōsh',
		'Qaryat Diyānā',
		'Ubaiyidh',
		'Umm Qaşr',
		'Ummal Barur',
		'Zobier',
	],
	Irán: [
		'Ahar',
		'Ahvāz',
		'Ajab Shīr',
		'Ali Shāh Iwaz',
		'Āqā Jarī',
		'Āzādshahr',
		'Āzādshahr',
		'Aznā',
		'Dasht-e Āzādegān',
		'Ecbatana',
		'Emamshahr',
		'Eqbālīyeh',
		'Ghareh Ziya Oddin',
		'Ghom',
		'Gonbad-e Qābūs',
		'Iranshahr',
		'Irāq',
		'Īstgāh-e Rāh Āhan-e Garmsār',
		'Īz̄eh',
		'Kwāsh',
		'Mshiz',
		'Nūrābād',
		'Nūrābād',
		'Omīdīyeh',
		'Oţāq Sarāy',
		'Qahremānshahr',
		'Qaleh-ye Marīvān',
		'Qaleh-ye Nāşerī',
		'Qarchak',
		'Qareh Zīyā Eddīn',
		'Qaşabeh-e Karaj',
		'Qazvín',
		'Qehfarukh',
		'Qeshm',
		'Qishm',
		'Qom',
		'Qorveh',
		'Rezāīyeh',
		'Teherán',
		'Urmía',
		'Xiraz',
	],
	Irlanda: [
		'An Muileann gCearr',
		'An Uaimh',
		'Áth an Ghainimh',
		'Athlone',
		'Baile Átha Cliath',
		'Baile Bhlainséir',
		'Baile Phámar',
		'Béal An Átha',
		'Blanchardstown',
		'Caisleán an Bharraigh',
		'Cill Airne',
		'Cill Dhéagláin',
		'Cill Droichid',
		'Cill Mhantáin',
		'Clondalkin',
		'Clonmel',
		'Cnoc Lín',
		'Condado de Dublín Sur',
		'Contae Átha Cliath Theas',
		'Cork',
		'Drogheda',
		'Droichead Átha',
		'Droichead Nua',
		'Dublin',
		'Dublín',
		'Dundalk',
		'Ennis',
		'Finglas',
		'Galway',
		'Inis',
		'Knocklyon',
		'Léim an Bhradáin',
		'Limerick',
		'Luimneach',
		'Maigh Nuad',
		'Mullach Íde',
		'Na Clocha Liatha',
		'Port Láirge',
		'Sligo',
		'South Dublin',
		'Swords',
		'Tallaght',
		'Trá Mhór',
		'Tulach Mhór',
		'Waterford',
	],
	Islandia: ['Reikiavik'],
	Israel: [
		'Abu Snan',
		'Acre',
		'Afula',
		'Āqir',
		'Ayun Kara',
		'Azata',
		'Baqa al-Gharbiyye',
		'Beer Yaaqov',
		"B'eyr-Sheva'",
		'Bnei Brak',
		'Ekron',
		'Eqrōn',
		'Etzion Geber',
		'Even Yehuda',
		'Evlayim',
		'Iarúsailéim',
		'Iksāl',
		'Iopē',
		'Ir Ha-Qdoosha',
		'Ir Ha-Qodesh',
		'Jiljulieh',
		'Jisr ez Zarqā',
		'Kadima-Tzoran',
		'Kefar Qesem',
		'Kefar Yohanah',
		'Kfar Kassem',
		'Kfar Saba',
		'Kfar Yafia',
		'Kfar Yasif',
		'Kfar Yavne',
		'Kfar Yeroham',
		'Kfar Yona',
		'Khirbet Ibyār el Leimūn',
		'Kiryat Ekron',
		'Kiryat Ono',
		'Maale Iron',
		'Me`ona `Ironit',
		'Mghar',
		'Migdal HaEmeq',
		'Ness Tziona',
		'Ness Ziona',
		'Ntanya',
		'Ofakim',
		'Or Aqiva',
		'Ptolemais',
		'Qastina Alef',
		'Qiryat Ata',
		'Qiryat Bialik',
		'Qiryat Eqron',
		'Qiryat Gat',
		'Qiryat Karmiel',
		"Qiryat Mal'aji",
		'Qiryat Motsqin',
		'Qiryat Naṣrat',
		'Qiryat Shmona',
		'Qiryat Tivon',
		'Qiryat Xemonà',
		'Qiryat Yam',
		'Ramat ha-Xaron',
		'Rishon le Ziyon',
		'Rishon Lsiyon',
		'Rosh HaAyin',
		'Sderot',
		'Seguev Xalom',
		'Sfat',
		'Tell Afif',
		'Tverya',
		'Ukreir',
		'Umm el Faḥm',
		'Umrashash',
		'Upper Nazareth',
		'Uyūn Qāra',
		'Yhud',
		'Yirkā',
		'Yirushalāyim',
		'Yokneam Illit',
		'Zikhron Yaaqov',
		'Zion',
	],
	Italia: [
		'Abano Terme',
		'Abbiategrasso',
		'Acerra',
		'Aci Castello',
		'Aci Catena',
		"Aci Sant'Antonio",
		'Acilia-Castel Fusano-Ostia Antica',
		'Acireale',
		'Acquaviva delle Fonti',
		'Acqui Terme',
		'Adelfia',
		'Adernó',
		'Adria',
		'Afragola',
		'Agliana',
		'Agrate Brianza',
		'Agrigento',
		'Agropoli',
		'Alessandria',
		'Altamura',
		'Ancona',
		'Andria',
		'Ansizio',
		'Anzio',
		'Aosta',
		'Apricena',
		'Aprilia',
		'Apuania',
		'Aquila degli Abruzzi',
		'Arenella',
		'Arezzo',
		'Ascoli Piceno',
		'Assemini',
		'Asti',
		'Augusta',
		'Avellino',
		'Aversa',
		'Avezzano',
		'Avola',
		'Avvocata',
		'Azzano Decimo',
		'Bari',
		'Bastia umbra',
		'Bellaria-Igea Marina',
		'Bérgamo',
		'Biella',
		'Bisceglie',
		'Bitonto',
		'Bolonia',
		'Bolzano',
		'Brescia',
		'Brindisi',
		'Busto Arsizio',
		'Cagliari',
		'Canosa di Puglia',
		'Carpi Centro',
		'Cassano al Jonio',
		'Cassano Allo Ionio',
		"Cassano d'Adda",
		"Castel San Pietro dell'Emilia",
		'Castelfranco Emilia',
		'Catania',
		"Cava de' Tirreni",
		'Cerignola',
		'Cesano Maderno',
		'Cesena',
		'Cinisello Balsamo',
		'Como',
		'Crema',
		'Cremona',
		'Crotona',
		'Cuneo',
		'Cusano Milanino',
		'Eboli',
		'Empoli',
		'Enna',
		'Ercolano',
		'Estàbia',
		'Fabriano',
		'Faenza',
		'Falconara Marittima',
		'Fano',
		'Fasano',
		'Favara',
		'Ferrara',
		'Fiano Romano',
		'Ficarazzi',
		'Fidenza',
		'Figline Valdarno',
		'Fiorano Modenese',
		"Fiorenzuola d'Arda",
		'Fiumicino',
		'Florencia',
		'Floridia',
		'Foggia',
		'Foligno',
		'Fondi',
		'Forerotta',
		'Forlì',
		'Formia',
		'Formigine',
		'Francavilla Fontana',
		'Frosinone',
		'Fucecchio',
		'Fuorigrotta',
		'Gallarate',
		'Gela',
		'Génova',
		'Ghedi',
		'Giarre',
		'Gioia del Colle',
		'Giovanni Rotondo',
		'Giugliano in Campania',
		'Giulianova',
		'Giussano',
		'Gravina in Puglia',
		'Grumo Appula',
		'Guidonia',
		'Iatrinoli',
		'Iesi',
		'Iglesias',
		'Imola',
		'Imperia',
		'Incino',
		'Istonio',
		'Ivrea',
		'Jesi',
		'La Spezia',
		'Lamezia Terme',
		"L'Aquila",
		'Latina',
		'Lecce',
		'Legnano',
		'Lido di Ostia',
		'Lido di Roma',
		'Littoria',
		'Livorno',
		'Locres Epizefiris',
		'Lucca',
		'Mailand',
		'Marano di Napoli',
		'Martina Franca',
		'Mediolanum',
		'Messina',
		'Mestre',
		'Milán',
		'Módena',
		'Monza',
		'Mugnano di Napoli',
		'Nápoles',
		'Nettuno',
		'Nichelino',
		'Nocera Inferiore',
		'Novara',
		'Nuoro',
		'Oderzo',
		'Olbia',
		'Omegna',
		'Opera',
		'Oristano',
		'Orta di Atella',
		'Ostuni',
		'Ottaviano',
		'Paderno Dugnano',
		'Padua',
		"Palazzolo sull'Oglio",
		'Palermo',
		'Pallanza-Intra-Suna',
		'Parma',
		'Perugia',
		'Pesaro',
		'Pescara',
		'Piacenza',
		'Pianura',
		'Pieve Emanuele',
		'Pisa',
		'Pistoia',
		'Plasencia',
		'Porto Empedocle',
		"Porto Sant'Elpidio",
		'Prato',
		'Provincia de Mantua',
		'Qualiano',
		'Quarto',
		"Quartu Sant'Elena",
		'Quattromiglia di Rende',
		'Ragusa',
		'Rávena',
		'Reggio Emilia',
		"Reggio nell'Emilia",
		'Regio de Calabria',
		'Resina',
		'Rho',
		'Rieti',
		'Rímini',
		'Rione Vomero',
		'Rionero in Vulture',
		'Rivoli',
		'Roma',
		"Romano d'Ezzelino",
		'Roseto degli Abruzzi',
		'Ruvo di Puglia',
		'San Benedetto del Tronto',
		"San Carlo All'Arena",
		'San Donà di Piave',
		'San Giorgio a Cremano',
		'San Giorgio Ionico',
		'San Giorgio Jonico',
		'San Giovanni a Teduccio',
		'San Giovanni in Fiore',
		'San Giovanni la Punta',
		'San Giovanni Lupatoto',
		'San Giuliano Milanese',
		'San Giuseppe Vesuviano',
		"Sant'Antonio Abate",
		'Scafati',
		'Scandicci',
		'Schio',
		'Sciacca',
		'Sesto Fiorentino',
		'Sesto San Giovanni',
		'Siena',
		'Siracusa',
		'Spaccaforno',
		'Spinea',
		'Spoleto',
		'Squinzano',
		'Syracuse',
		'Tarento',
		'Teate',
		'Teramo',
		'Tergeste',
		'Termini Imerese',
		'Terni',
		'Tibur',
		'Ticinum',
		'Torí',
		'Torre del Greco',
		'Trani',
		'Trapani',
		'Tremestieri Etneo',
		'Trento',
		'Treviso',
		"Trezzo sull'Adda",
		'Trieste',
		'Turín',
		'Udine',
		'Umbertide',
		'Varese',
		'Velletri',
		'Venecia',
		'Vercelli',
		'Verona',
		'Viareggio',
		'Vicenza',
		'Vico Equense',
		'Villa Adriana',
		'Vomero',
		'Xaca',
		'Zola',
	],
	Jordania: [
		'Ahamant',
		'Ajlūn',
		'Ammán',
		'Aqaba',
		'Azrā',
		'Djerash',
		'Irbid',
		'Izrā',
		'Qal`at el `Aqaba',
		'Qalat az Zarqā',
		'Qīr Moāv',
		'Rabbah',
		'Umm as Summāq',
	],
	Kazajstán: [
		'Alma-Ata',
		'Aqsay',
		'Aqsū',
		'Astaná',
		'Atyrau',
		'Ayagoz',
		'Ayteke Bi',
		'Djarkent',
		'Dzhanatas',
		'Dzharkent',
		'Dzhetygara',
		'Dzhetysay',
		'Dzhusaly',
		'Ekibastuzugol',
		'Emba',
		'Īlīch',
		'Kyzylorda',
		'Lenger-Ugol',
		'Oktyabr',
		'Otegen Batyra',
		'Qaraghandy',
		'Qaraötkel',
		'Qonayev',
		'Qostanay',
		'Saro-Ozak',
		'Sary-Uzek',
		'Shakanskiye Vyselki',
		'Ssary-Agatsch',
		'Syrdarinskiy',
		'Turar Ryskulov',
		'Ximkent',
		'Zhambyl',
		'Zhangaözen',
		'Zhezkazgan',
		'Ziryanovsk',
		'Zyryanovsk',
	],
	Kirguistán: [
		'Biskek',
		'Bystrorechenskoye',
		'Dmitriyevka',
		'Durbeljin',
		'Dyurbeljin',
		'Dzhalal-Abad',
		'Frunze',
		'Imeni Mikoyana',
		'Iradan',
		'Ivanovna',
		'Kyzyl-Adyr',
		'Kyzyl-Kyya',
		'Kyzyl-Suu',
		'Kzyl-Kiya',
		'Oix',
		'Özgön',
		'Pishkek',
		'Rybachye',
		'Tjup',
		'Uch-Korgon',
		'Uzgen',
		'Ysyk-Köl',
	],
	Kosovo: [
		'Dagash',
		'Đakovica',
		'Dragashi',
		'Drenas',
		'Ferizaj',
		'Fushë-Kosova',
		'Gilan',
		'Gjakovë',
		'Gjilan',
		'Gllaboder',
		'Glogovce',
		'Gnjilane',
		'Istok',
		'Kosovska Mitrovica',
		'Llazicë',
		'Lumthatë',
		'Mitrovica',
		'Përzeren',
		'Priština',
		'Prizren',
		'Suva Reka',
		'Theranda',
		'Vushtrri',
		'Zubin Potoku',
		'Zvečan',
	],
	Kuwait: ['Al Ahmadi', 'Al Ifhaihil', 'Ciudad de Kuwait', 'Iahara', 'Koweit', 'Madīnat al Kuwayt'],
	Letonia: [
		'Daugavpils',
		'Elgava',
		'Iyelgava',
		'Jēkabpils',
		'Jelgava',
		'Jūrmala',
		'Leepaja',
		'Liepāja',
		'Mitava',
		'Ogre',
		'Riga',
		'Rigas Iurmala',
		'Rīgas Jormalas Pilsēta',
		'Rīgas Jūrmala',
		"Rizhskoye Vzmor'ye",
		'Ryezhitsa',
		'Tsesis',
		'Wentspils',
		'Windau',
		'Yelgava',
		'Yurmala',
	],
	Líbano: [
		'Aaley',
		'Bayrūt',
		'Bcharrī',
		'Beirut',
		'Bsharri',
		'Byblos',
		'Djébail',
		'Djounie',
		'Ghazieh',
		'Jbeil',
		'Tyre',
	],
	Liechtenstein: ['Liechtenstein'],
	Lituania: [
		'Caunas',
		'Dainava (Kaunas)',
		'Eiguliai',
		'Fabijoniškės',
		'Ionava',
		'Ionishkis',
		'Jonava',
		'Justiniškės',
		'Kaunas',
		'Klaipėda',
		'Kovno',
		'Memel',
		'Murawlewo',
		'Myasto Birzhay',
		'Myasto Kretinga',
		'Myasto Rokishkis',
		'Nauya Vilnya',
		'Olita',
		'Onikschty',
		'Palemonas',
		'Panevezys',
		'Plungė',
		'Schaulen',
		'Shaulyay',
		'Šiauliai',
		'Snechkus',
		'Sokniai',
		'Szawle',
		'Uciana',
		'Ukmergė',
		'Utena',
		'Uzjany',
		'Vilna',
		"Vil'nyus",
		'Wilno',
		'Yonava',
		'Yonishkis',
		'Yurbarkas',
	],
	Luxemburgo: ['Luxemburgo', 'Ciudad de Luxemburgo', 'Letzeburg'],
	Macedonia: [
		'Akhris',
		'Bitola',
		'Centar Župa',
		'Djorče Petrov',
		'Gjorče Petro',
		'Gorče Petrov',
		'Gostivar',
		'Ilinden',
		'Ishtib',
		'Kisela Voda',
		'Kumanovo',
		'Monastir',
		'Ocrida',
		'Ohrid',
		'Okhri',
		'Perlepé',
		'Prilep',
		'Qalqan Delen',
		'Shkup',
		'Sykies - Macedonia Central',
		'Shtip',
		'Skopje',
		'Sveti Nikole',
		'Tetovo',
		'Tikveš',
		'Titov Veles',
		'Usküb',
		'Ustrugha',
		'Ustrumcha',
		'Veles',
		'Zelino',
	],
	Malta: [
		'Attard',
		'Bulebel Il Cbir',
		'Ghain Il Cbira',
		'Gzira',
		'Is-Swieqi',
		'Kunsill Lokali Fgura',
		'L-Imsida',
		'Msida',
		'Qormi',
		'San Ġwann',
		'San Julián',
		'San Paul Amere',
		'Sliema',
		'Wied il Ghain',
	],
	Moldavia: [
		'Beltsi',
		'Beltsy',
		'Bender',
		'Bliceni',
		'Byelcy',
		'Chișinău',
		'Dnestrovsc',
		'Dubăsari',
		'Edineț',
		'Florești',
		'Gynchesht',
		'Ialoveni',
		'Kelerashi-Tyrg',
		'Kishiniv',
		'Râbnița',
		'Rashkani-Tyrg',
		'Rîbnița',
		'Rybniza',
		'Ryshkany',
		'Synzheria',
		'Tighina',
		'Tiráspol',
		'Ukgeni Tyrg',
		'Ungen Tyrg',
		'Ungheni',
		'Vulcănești',
		'Yedintsy-Tyrg',
	],
	Monaco: ['Monaco-Ville', 'Mónaco'],
	Montenegro: ['Ivangrad', 'Ljevlja', 'Nikšić', 'Pljevlja', 'Podgorica', 'Titograd', 'Ulcinj'],
	Noruega: [
		'Aalesund',
		'Asker',
		'Bergen',
		'Drammen',
		'Egersund',
		'Fredrikstad',
		'Gjøvik',
		'Kristiansand',
		'Kristiansand Sør',
		'Lillestrøm',
		'Oslo',
		'Skien',
		'Stavanger',
		'Tromsø',
		'Trondheim',
		'Ytrebygda',
	],
	Palestina: [
		'Adh Dhahiriya',
		'Al Ubaydīyah',
		'An Nuşayrāt',
		'Az̧ Z̧āhirīyah',
		'Azzā',
		'Bayt Ūmmar',
		'Djenin',
		'Eḍh Ḍhāhiriya',
		'Ghazza',
		'Idhnā',
		'Ireachó',
		'Jan Yunís',
		'Jerusalem East',
		'Jinin',
		'Kfar Saba',
		'Khan Younes',
		'Sykhem',
		'Yirīḩū',
	],
	Polonia: [
		'Allenshteyn',
		'Augustów',
		'Auschwitz',
		'Avgustov',
		'Belostok',
		'Bemowo',
		'Biała Podlaska',
		'Białołeka',
		'Białystok',
		'Bielany',
		'Bielsko-Biała',
		'Bjelostock',
		'Breslavia',
		'Bromberg',
		'Busko-Zdrój',
		'Byala',
		'Bydgoszcz',
		'Byelostok',
		'Bystrzyca Kłodzka',
		'Bytom',
		'Bytów',
		'Catowice',
		'Chenstochov',
		'Cieplice Śląskie Zdrój',
		'Cracovia',
		'Cylichów',
		'Czarnków',
		'Czechowice-Dziedzice',
		'Czeladź',
		'Czerwionka-Leszczyny',
		'Częstochowa',
		'Człuchów',
		'Dąbrowa Górnicza',
		'Danzig',
		'Dombrowa',
		'Drawsko Pomorskie',
		'Dyhernfurth',
		'Dyrłów',
		'Działdowo',
		'Dzierżoniów',
		'Eichenbrück',
		'Elbląg',
		'Elblëng',
		'Ełk',
		'Fordon',
		'Gdańsk',
		'Gdynia',
		'Ghipczyce',
		'Gierłoż',
		'Giżycko',
		'Glatz',
		'Gliwice',
		'Glogovia',
		'Głowno',
		'Głuchołazy',
		'Gmina Brwinów',
		'Gmina Jędrzejów',
		'Gmina Końskie',
		'Gmina Śrem',
		'Gmina Strzelin',
		'Gmina Świebodzin',
		'Gmina Świecie',
		'Gniezno',
		'Gorzów Wielkopolski',
		'Gotenhafen',
		'Grudziądz',
		'Gruenberg',
		'Hohensalza',
		'Hrubieszów',
		'Iława',
		'Inowrocław',
		'Irownoclaw',
		'Jabłonna-Legionowo',
		'Jarocin',
		'Jarosław',
		'Jasło',
		'Jastrzębie-Zdrój',
		'Jaworzno',
		'Jelcz-Laskowice',
		'Jelenia Góra',
		'Johannisburg',
		'Kalisz',
		'Katowice',
		'Kędzierzyn-Koźle',
		"Kel'tsy",
		'Kezlin',
		"Kheyl'sberg",
		'Kholm',
		'Khoynitsy',
		'Khshanov',
		'Kielce',
		'Kłobuck',
		'Kłodzko',
		'Kluczbork',
		'Knurów',
		'Königshütte',
		'Konstancin-Jeziorna',
		'Kostrzyn nad Odrą',
		'Kostsyan',
		'Koszalin',
		'Krakow',
		'Królewska Huta',
		'Krosno Odrzańskie',
		'Krynica Zdrój',
		'Kshonev',
		'Kudowa-Zdrój',
		'Kutno',
		'Kwidzyn',
		'Legnica',
		'Leslau',
		'Leszno',
		'Lignica',
		'Lodz',
		'Łomża',
		'Lubin',
		'Lublin',
		'Lyubartov',
		'Lyublin',
		'Melets',
		'Mielec',
		'Mława',
		'Mokotów',
		'Mrągowo',
		'Myślenice',
		'Myślibórz',
		'Mysłowice',
		'Myszków',
		'Neu Sandez',
		'Neustadt in Oberschlesien',
		'Niesse',
		'Novy Dvor',
		'Novy-Sonch',
		'Nowy Dwór',
		'Nowy Sącz',
		'Nysa',
		'Oberlasisk',
		'Oborniki',
		'Ochota',
		'Odertal',
		'Oels',
		'Ohiau',
		'Oława',
		'Oleśnica',
		"Ol'kush",
		'Olkusz',
		'Olsztyn',
		'Opoczno',
		'Opole',
		'Ortelsberg',
		'Ostróda',
		'Ostrołęka',
		'Ostrów Mazowiecka',
		'Ostrów Wielkopolski',
		'Ostrowiec Świętokrzyski',
		'Oświęcim',
		'Otwock',
		'Ozorków',
		'Pabyanitsy',
		'Peremyshl',
		'Petrikau',
		'Piekary Śląskie',
		'Piekary Wielkie',
		'Piła',
		'Piotrkow Trybunalski',
		'Płock',
		'Płońsk',
		'Polkwitz Kreis Glogau',
		'Posnania',
		'Powstańców Śląskich Wschód',
		'Praga Północ',
		'Praga Południe',
		'Pruszcz Gdański',
		'Pruszków',
		'Przemyśl',
		'Pshasnysh',
		'Pshemysl',
		'Pszczyna',
		'Pszów',
		'Puławy',
		'Pyritz',
		'Pyskowice',
		'Rabka-Zdrój',
		'Racibórz',
		'Radom',
		'Radomsko',
		'Reichshof',
		'Rejon placu Grunwaldzkiego',
		'Rejon placu Świętego Macieja',
		'Rejon ulicy Traugutta',
		'Ruda Śląska',
		'Rumia',
		'Rybnik',
		'Rydułtowy',
		'Rypin',
		'Rzeszów',
		'Schneidemühl',
		'Schweidnitz',
		'Schwientochlowitz',
		"Sedl'tse",
		'Siedlce',
		'Siemianowice Śląskie',
		'Skarżysko-Kamienna',
		'Skawina',
		'Skierniewice',
		'Skolimów-Konstancin',
		'Sławno',
		'Słubice',
		'Słupsk',
		'Sosnowiec',
		'Sprottau',
		'Środa Wielkopolska',
		'Śródmieście',
		'Stalowa Wola',
		'Starachowice-Wierzbnik',
		'Starogard Gdański',
		'Stettin',
		'Stolpe',
		'Strzelce Opolskie',
		'Suwałki',
		'Swarzędz',
		'Swidnica',
		'Świdnik',
		'Świdnik Duży',
		'Świdwin',
		'Świebodzice',
		'Świętochłowice',
		'Świnoujście',
		'Syców',
		'Szamotuły',
		'Szczecin',
		'Szczecinek',
		'Szczytno',
		'Targówek',
		'Tarnów',
		'Tarnowskie Góry',
		'Tczew',
		'Thorn',
		'Tomaszów Mazowiecki',
		"Tomoshuv Lyubel'ski",
		'Toruń',
		'Tschenstochau',
		'Tsekhanov',
		'Turek',
		'Tychy',
		'Ursus',
		'Ursynów',
		'Ustka',
		'Ustroń',
		'Varsovia',
		'Veykherovo',
		'Vlodava',
		'Vrotslav',
		'Vyshkov',
		'Vzhesnya',
		'Vzhesnya',
		'Wałbrzych',
		'Warsaw',
		'Wawer',
		'Wejherowo',
		'Władysławowo',
		'Włochy',
		'Włocławek',
		'Włodawa',
		'Włoszczowa',
		'Wodzisław Śląski',
		'Wola',
		'Wołomin',
		'Wroclaw',
		'Wronki',
		'Września',
		'Wschowa',
		'Wyszków',
		'Yaroslav',
		'Yaslo',
		'Zabracze',
		'Zabrze',
		'Zakłady Samochodowe Jelcz SA',
		'Zalbórz',
		'Zamość',
		'Żary',
		'Zawiercie',
		'Zduńska Wola',
		'Zdzieszowice',
		'Zegań',
		'Zgierz',
		'Zgorzelec',
		'Zgorzelisko',
		'Zheshev',
		'Zięciuki',
		'Ziegenhals',
		'Zielenzig',
		'Zielona Góra',
		'Zielonka',
		'Złocieniec',
		'Złotoryja',
		'Złotów',
		'Żnin',
		'Żoliborz',
		'Zóraw',
		'Żory',
		'Züllichau',
		'Zwyiec',
		'Żyrardów',
		'Żywiec',
	],
	Portugal: [
		'Abrantes',
		'Afurada de Baixo',
		'Águas Santas',
		'Águeda',
		'Ajuda',
		'Amadora',
		'Amora',
		'Aveiro',
		'Aver-o-Mar',
		'Avintes',
		'Azambuja',
		'Azeitão',
		'Azenha',
		'Azevedo',
		'Braga',
		'Campo De Ourique',
		'Cidade Universitária',
		'Coímbra',
		'Custoias',
		'Damaia',
		'Ébora',
		'Entroncamento',
		'Ermesinde',
		'Espinho',
		'Evora',
		'Fânzeres',
		'Faro',
		'Felgueiras',
		'Figueira da Foz',
		'Guarda',
		'Guimarães',
		'Ílhavo',
		'Lisboa',
		'Lordelo do Ouro',
		'Loures',
		'Lumiar',
		'Óbidos',
		'Odivelas',
		'Oeiras',
		'Olhão',
		'Olival',
		'Oliveira de Azeméis',
		'Oliveira do Douro',
		'Oporto',
		'Ourém',
		'Ovar',
		'Porto',
		'Póvoa de Santa Iria',
		'Póvoa de Santo Adrião',
		'Quarteira',
		'Quelfes',
		'Queluz',
		'Quinta Do Conde',
		'Rio de Mouro',
		'Rio Tinto',
		'Santa Iria da Azóia',
		'Santa Maria dos Olivais',
		'Santo António dos Olivais',
		'Santo Ovídio',
		'São Braz de Aportel',
		'São Domingos de Rana',
		'São João de Madeira',
		'São Jorge de Arroios',
		'São Mamede de Infesta',
		'São Tiago de Custoias',
		'Setúbal',
		'Unhos',
		'Vila Franca de Xira',
		'Vila Nova de Gaia',
	],
	'Reino Unido': [
		'A Bhruaich',
		'Abercarn',
		'Aberdare',
		'Aberdaugleddau',
		'Aberdeen',
		'Abergavenny',
		'Abergele',
		'Abertawe',
		'Abertillery',
		'Aberystwyth',
		'Abingdon',
		'Abingdon-on-Thames',
		'Accrington',
		'Acocks Green',
		'Acton',
		'Addlestone',
		'Adwick le Street',
		'Áird Rosain',
		'Airdrie',
		'Amersham',
		'Amersham on the Hill',
		'Ammanford',
		'Ampthill',
		'An Caisleán Riabhach',
		'An Eaglais Bhreac',
		'An Geal Áth',
		'An Leargaidh Ghallda',
		'An Oghmagh',
		'An Ómaigh',
		'An Srath Bán',
		'An t-Árd Ruigh',
		'An tïúr',
		'An t-Srón',
		'An t-Sròn Reamhar',
		'Aontroim',
		'Archway',
		'Ard Mhacha',
		'Ard Mhic Nasca',
		'Ashby-de-la-Zouch',
		'Ashford',
		'Ashington',
		'Ashton in Makerfield',
		'Ashton-under-Lyne',
		'Aston',
		'Atherstone',
		'Atherton',
		'Attleborough',
		'Aylesbury',
		'Aylestone',
		'Ayr',
		'Baile Dhún Léibhe',
		'Baile Eilidh',
		'Baile Fharfair',
		'Baile Iain',
		'Baile nam Feusgan',
		'Baile Nua na hArda',
		'Barking Town',
		'Barrow in Furness',
		'Barton upon Humber',
		'Basildon',
		'Béal Feirste',
		'Becontree',
		'Bedford',
		'Belfast',
		'Benfleet Theas',
		'Berwick-upon-Tweed',
		'Bexley',
		'Birkenhead',
		'Birmingham',
		'Bishop Auckland',
		"Bishop's Cleeve",
		'Blackburn',
		'Blackheath',
		'Blackpool',
		'Blackwall',
		'Blaydon',
		'Blaydon-on-Tyne',
		'Bletchley',
		'Bloxwich',
		'Blyth',
		'Bognor Regis',
		'Bolton',
		'Bolton upon Dearne',
		'Bournemouth',
		'Bracknell',
		'Bradford',
		'Brent',
		'Brierley Hill',
		'Brighton',
		'Brístol',
		'Briton Ferry',
		'Bromwich Thiar',
		'Buckley',
		'Burgess Hill',
		'Burnley',
		'Burton upon Trent',
		'Burton-on-Trent',
		'Bury St Edmunds',
		'Bwcle',
		'Cambridge',
		'Canary Wharf',
		'Canvey Island',
		'Cardiff',
		'Cárn Fheusta',
		'Carraig Fhearghais',
		'Cas-gwent',
		'Casnewydd',
		'Cathair Luail',
		'Ceann a Bhárra',
		'Ceann Phádraig',
		'Cheadle Hulme',
		'Cheltenham',
		'Chepping',
		'Cill Fhinnean',
		'Cill Mheárnaig',
		'Cille Bhríghde an Ear',
		'Cille Phádraig Úr',
		'City of Westminster',
		'City of Worcester',
		'Clacton-on-Sea',
		'Cleckheaton',
		'Cleethorpes',
		'Clevedon',
		'Clitheroe',
		'Clydebank',
		'Colchester',
		'Comar nan Allt',
		'Coventry',
		'Craigavon',
		'Cramlington',
		'Crawley',
		'Creag Abhann',
		'Crewe',
		'Cricklewood',
		'Crosby',
		'Crowthorne',
		'Croydon',
		'Croydon Grants',
		'Cúil Raithin',
		'Cumbernauld',
		'Cwmbran',
		'Dagenham',
		'Darlington',
		'Dartford',
		'Darwen',
		'Derby',
		'Derry',
		'Dhoire',
		'Doire',
		'Doncaster',
		'Dover',
		'Drochaid an Chóta',
		'Droitwich',
		'Dronfield',
		'Droylsden',
		'Dudley',
		'Dún Déagh',
		'Dún Éideann',
		'Dún Phárlain',
		'Dún Phris',
		'Dundee',
		'Dunfermline',
		'Dunstable',
		'Durham',
		'Eabhrac',
		'Ealing Common',
		'Earl Shilton',
		'Earlsfield',
		'East Barnet',
		'East Dereham',
		'East Dulwich',
		'East Grinstead',
		'East Kilbride',
		'East Molesey',
		'East Retford',
		'East Sheen',
		'Eastbourne',
		'Eastleigh',
		'Eastwood',
		'Eaton Socon',
		'Ebbw Vale',
		'Eccles',
		'Edgwarebury',
		'Edimburgo',
		'Edmonton',
		'Egham',
		'Eilginn',
		'Elgin',
		'Ellesmere Port',
		'Ellesmere Port Town',
		'Eltham',
		'Emerson Park',
		'Emsworth',
		'Enfield',
		'Enfield Town',
		'Enniskillen',
		'Epping',
		'Epsom',
		'Esher',
		'Evesham',
		'Evington',
		'Ewell',
		'Exeter',
		'Exmouth',
		'Fair Oak',
		'Falkirk',
		'Falmouth',
		'Fareham',
		'Farnborough',
		'Farnham',
		'Farnworth',
		'Felixstowe',
		'Felling',
		'Feltham',
		'Finchley',
		'Fleet',
		'Fleetwood',
		'Flint',
		'Flitwick',
		'Folkestone',
		'Forest Hill',
		'Fulham',
		'Fulwood',
		'Fylde',
		'Gateshead',
		'Gateshead-on-Tyne',
		'Gillingham',
		'Glasgow',
		'Gleann Iucha',
		'Gleann Ráthais',
		'Glen Parva',
		'Glossop',
		'Gloucester',
		'Gosport',
		'Gravesend',
		'Grays',
		'Grays Thurrock',
		'Great Wyrley',
		'Great Yarmouth',
		'Grimsby',
		'Guildford',
		'Halifax',
		'Harlow',
		'Harrogate',
		'Harrow',
		'Hartlepool',
		'Hastings',
		'Hebburn-on-Tyne',
		'Hemel Hempstead',
		'Hereford',
		'High Barnet',
		'High Blantyre',
		'High Peak',
		'High Peak District',
		'High Wycombe',
		'Highbury',
		'Hinckley',
		'Hindley',
		'Hitchin',
		'Holloway',
		'Horsham',
		'Houghton-Le-Spring',
		'Houghton-Le-Spring',
		'Hounslow',
		'Hove',
		'Hucknall',
		'Huddersfield',
		'Hull',
		'Huntingdon',
		'Huyton',
		'Hwlffordd',
		'Hyde',
		'Hyde Park',
		'Hythe',
		'Ickenham',
		'Ilford',
		'Ilfracombe',
		'Ilkeston',
		'Ilkley',
		'Immingham',
		'Inbhear Nis',
		'Inbhir Áir',
		'Inbhir Úraidh',
		'Inis Ceithlann',
		'Inverness',
		'Inverurie',
		'Ipswich',
		'Irbhinn',
		'Irlam',
		'Isleworth',
		'Islington',
		'Iúir Cinn Trá',
		'Ivybridge',
		'Jarrow-on-Tyne',
		'Johnstone',
		'Kettering',
		'Kidderminster',
		'Kings Lynn',
		'Kingston upon Hull',
		'Kingston upon Thames',
		'Kingswood',
		'Kirkby in Ashfield',
		'Kirkcaldy',
		'Knaresborough',
		'Knightsbridge and Belgravia',
		'Knottingley',
		'Knotty Ash',
		'Knowle',
		'Knutsford',
		'Lancaster',
		'Learpholl',
		'Leeds',
		'Leicester',
		'Leicester Forest East',
		'Léim an Mhadaidh',
		'Letchworth Garden',
		'Lincoln',
		'Lios na gCearrbhach',
		'Lisburn',
		'Liverpool',
		'Llandudno',
		'Llanelli',
		'Llansawel',
		'Llantrisant',
		'Llantwit Major',
		'London Borough of Bexley',
		'London Borough of Brent',
		'London Borough of Hounslow',
		'Londonderry',
		'Londonderry County Borough',
		'Londonderry County Borough',
		'Londres',
		'Long Eaton',
		'Loughborough',
		'Lower Earley',
		'Lowestoft',
		'Luton',
		'Lytham St Annes',
		'Mánchester',
		'Mansfield',
		'Meikle Earnock',
		'Mendip',
		'Merthyr Tudful',
		'Merthyr Tydfil',
		'Middlesbrough',
		'Milton Keynes',
		'Mitcham',
		'Muileann Dháibhidh',
		'Municipio de Barnet',
		'Newark on Trent',
		'Newark upon Trent',
		'Newcastle-under-Lyme',
		'Newcastle-upon-Tyne',
		'Newport',
		'Newton Abbot',
		'Newton Aycliffe',
		'Newtownabbey',
		'Northampton',
		'Norwich',
		'Nottingham',
		'Nuneaton',
		'Oadby',
		'Oakham',
		'Obar Bhrothaig',
		'Obar Dheathain',
		'Oileán Canvey',
		'Old Swan',
		'Oldham',
		'Otley',
		'Oxford',
		'Oxted',
		'Peckham',
		'Peighinn na Cuthaig',
		'Peterborough',
		'Plymouth',
		'Plymstock',
		'Ponders End',
		'Poole',
		'Port Ghlaschú',
		'Port Glasgow',
		'Portsmouth',
		'Poulton le Fylde',
		'Preston',
		'Pudsey',
		'Purley',
		'Putney',
		'Pyle',
		'Radditch',
		'Ramsgate',
		'Reading',
		'Redditch',
		'Rhondda',
		'Rhosllannerchrugog',
		'Rhydaman',
		'Rhyl',
		'Rochdale',
		'Romford',
		'Ros Fhíobh',
		'Ross on Wye',
		'Rossendale',
		'Rotherham',
		'Royal Leamington Spa',
		'Royal Sutton Coldfield',
		'Royal Tunbridge Wells',
		'Rugby',
		'Ruislip',
		'Runcorn',
		'Rushden',
		'Ryde',
		'Ryhope',
		'Ryton',
		'Saint Helens',
		'Saint Peter Extra',
		'Saint Peters',
		'Scarborough',
		'Scunthorpe',
		'Sheffield',
		'Shields Theas',
		'Shields Thuaidh',
		'Shrewsbury',
		'Skegness',
		'Skelmersdale',
		'Sleaford',
		'Slough',
		'Smethwick',
		'Snaresbrook',
		'Snodland',
		'Solihull',
		'South Croydon',
		'South Ockendon',
		'South Shields',
		'Southall',
		'Southampton',
		'Southend-on-Sea',
		'Southport',
		'Spalding',
		'Speke',
		'Spennymoor',
		'Spitalfields',
		'Srath Bhroc',
		'Sruighle',
		'St Albans',
		'St Austell',
		'St. Helens',
		'Staines-upon-Thames',
		'Stamford Hill',
		'Stevenage',
		'Stockport',
		'Stockton-on-Tees',
		'Stoke-on-Trent',
		'Stoke-upon-Trent',
		'Stratford-upon-Avon',
		'Sunderland',
		'Sutton',
		'Sutton in Ashfield',
		'Swadlincote',
		'Swanage',
		'Swanley',
		'Swanscombe',
		'Swansea',
		'Swindon',
		'Swinton',
		'Syston',
		'Taigh na h-Uiseig',
		'Tamworth',
		'Taunton',
		'Telford',
		'Thanet',
		'Thornton-Cleveleys',
		'Thornton-Cleveleys',
		'Tipton',
		'Tonypandy',
		'Torquay',
		'Tottenham',
		'Trowbridge',
		'Tyldesley',
		'Tynemouth',
		'Uckfield',
		'Ulverston',
		'Upper Norwood',
		'Urmston',
		'Uttoxeter',
		'Uxbridge',
		'Vincent Square',
		'Wakefield',
		'Walkden',
		'Wallasey',
		'Wallsend-on-Tyne',
		'Walsall',
		'Waltham Abbey',
		'Walthamstow',
		'Warrington',
		'Warwick',
		'Washington',
		'Washington New Town',
		'Waterlooville',
		'Watford',
		'Wath upon Dearne',
		'Wednesfield',
		'Welling',
		'Wellingborough',
		'Welwyn Garden',
		'Welwyn Garden',
		'Wembley',
		'West Bridgford',
		'West Bromwich',
		'West Ealing',
		'West Horsham',
		'Westminster',
		'Weston-super-Mare',
		'Weymouth',
		'Whickham',
		'Whiston',
		'Whitburn',
		'Whitby',
		'Whitechapel',
		'Whitefield',
		'Whitehaven',
		'Whitley Bay',
		'Whitstable',
		'Whittlesey',
		'Widnes',
		'Wigan',
		'Willesden',
		'Wimbledon',
		'Winchester',
		'Windsor',
		'Woking',
		'Wolverhampton',
		'Worcester',
		'Worksop',
		'Worthing',
		'Wrexham',
		'Y Fflint',
		'Yarmouth',
		'Yate',
		'Yeadon',
		'Yeovil',
		'York',
		'Yr Wyddgrug',
		'Ystalyfera',
	],
	Rumanía: [
		'Ad Judul',
		'Adjud',
		'Aiud',
		'Alba Iulia',
		'Altarad',
		'Arad',
		'Aradinum Vetus',
		'Avrig',
		'Bacău',
		'Baia Mare',
		'Baia Sprie',
		'Bîrlad',
		'Bistrița',
		'Blaj',
		'Botoșani',
		'Braila',
		'Brașov',
		'Bucarest',
		'Bumbești-Jiu',
		'Buzău',
		'Câmpia Turzii',
		'Ciudadela Blanca',
		'Cluj-Napoca',
		'Constanza',
		'Copou',
		'Copou-Târg',
		'Craiova',
		'Csikszereda',
		'Cugir',
		'Curtea de Argeș',
		'Drăgășani',
		'Drobeta-Turnu Severin',
		'Dzombolj',
		'Făgăraș',
		'Fălticeni',
		'Fetești',
		'Filiași',
		'Focșani',
		'Freidorf',
		'Galata',
		'Galați',
		'Gheorgheni',
		'Gherla',
		'Giurgiu',
		'Gran Varadino',
		'Gura Humorului',
		'Gyergyo',
		'Gyulafehérvár',
		'Hermannstadt',
		'Hunedoara',
		'Huși',
		'Ianca',
		'Iași',
		'Ilasi',
		'Jassy',
		'Jibou',
		'Jilava',
		'Jimbolia',
		'Jósefvárosa',
		'Josephs-Stadt',
		'Karácsonkő',
		'Kendetelep',
		'Klausenburg',
		'Koloszvár',
		'Kronstant',
		'Küstenja',
		'Kyustendja',
		'Maros-Vásárhely',
		'Micălaca',
		'Munteni',
		'Murășel',
		'Nagy-Szében',
		'Nagy-Várad',
		'Negrești-Oaș',
		'Ocna Mureș',
		'Odorheiu Secuiesc',
		'Oláh-Lugos',
		'Ópécska',
		'Oprișeni',
		'Oradea',
		'Orașu Stalin',
		'Orodinum',
		'Oțelu Roșu',
		'Öthalom',
		'Otopeni',
		'Ovidiu',
		'Păcureț',
		'Pecica Ungurească',
		'Piatra Neamț',
		'Pietroșani',
		'Pitești',
		'Ploiești',
		'Podgoria',
		'Râmnicu Sărat',
		'Râmnicu Vâlcea',
		'Reșița',
		'Rîmnicu Sărat',
		'Rîmnicu Vîlcea',
		'Roman',
		'Sector 1',
		'Sector 2',
		'Sector 3',
		'Sector 4',
		'Sector 5',
		'Sector 6',
		'Sfânta Ana',
		'Sfântu Gheorghe',
		'Sibiu',
		'Slatina',
		'Slobozia',
		'Socol',
		'Striharet',
		'Suceava',
		'Szabadfalu',
		'Szatmár',
		'Székelyudvarhely',
		'Sziget',
		'Targòvixte',
		'Targu Jiu',
		'Târgu Jiu',
		'Târgu Mureș',
		'Târgu Ocna',
		'Tcherna Voda',
		'Tecuci',
		'Temișoara',
		'Timișoara',
		'Tîmpești',
		'Tîrgu Jiu',
		'Tîrnăveni',
		'Tulcea',
		'Turda',
		'Turgul Mures',
		'Turnu Măgurele',
		'Tyrgu-Muresh',
		'Ucea',
		'Urlați',
		'Urziceni',
		'Vaslui',
		'Vladimirescu',
		'Vulcan',
		'Walachisch-Lugosch',
		'Yassi',
		'Zalău',
		'Zeiden',
		'Zelau',
		'Zernest',
		'Zilah',
		'Žimbolija',
		'Zimnicea',
		'Zombolj',
		'Zsigmondháza',
		'Zsombolya',
	],
	Rusia: [
		'Abinsk',
		'Áchinsk',
		'Achkhoy-Martan',
		'Achty',
		'Adlersky City District',
		'Admiralteisky',
		'Adygeysk',
		'Afipskiy',
		'Agriz',
		'Akademicheskoe',
		'Akhtubinsk',
		'Akhty',
		'Akhtyrskiy',
		'Aksay',
		'Aksinino',
		'Aleksándrov',
		'Aleksandrovsk-Grushevskiy',
		'Aleksandrovsk-Grushevskoy',
		'Alekseyevo',
		'Almetyevsk',
		"Al'met'yevsk",
		'Altufyevskiy',
		'Aminyevo',
		'Anapa',
		'Andropov',
		'Apatity',
		'Aprelevka',
		'Apsheronsk',
		'Arkhangelsk',
		'Armavir',
		'Arzamas',
		'Asow',
		'Astracán',
		'Atkarsk',
		'Avtovo',
		'Avtury',
		'Ayutinskiy',
		'Aznakayevo',
		'Azov',
		'Bachi-Yurt',
		'Baçin-Yurt',
		'Balakovo',
		'Balashikha',
		'Baltser',
		'Batrak Zernosovkhoz',
		'Belaya Glina',
		'Bélgorod',
		'Bibirevo',
		'Biryulëvo',
		'Biryulëvo Zapadnoye',
		'Bjelomorsk',
		'Blagodarnyy',
		'Bobriki',
		'Bogorodskoye',
		'Brat”yevo',
		'Brateyevo',
		'Bryansk',
		'Bsatsevo',
		'Budyonnovsk',
		'Bugulma',
		'Byelaya Kalitva',
		'Byelokhohmitski Zavod',
		'Byelomorsk',
		'Bykovo',
		'Byrodinskiy',
		'Byselki',
		'Centralniy',
		'Černjahovsk',
		'Chassaw-Jurt',
		'Cheboksary',
		'Chegem Vtoroy',
		'Cherepovéts',
		'Cherkessk',
		'Chertanovo Yuzhnoye',
		'Dachnoye',
		'Dagestanskiye Ogni',
		'Davydkovo',
		'Derbent',
		'Derevnya Aftova',
		'Derevnya Ukovskaya',
		'Dimitrovgrad',
		'Distrito de Ádler',
		'Distrito de Ádler',
		'Djatkowa',
		'Dmítrov',
		'Dolgoprudny',
		'Domodedovo',
		'Donetsk',
		'Dorogobuzh na Dnepre',
		'Dorogomilovo',
		'Drozhzhino',
		'Dubná',
		'Dvoriki',
		'Dvubratskiy',
		'Dvydovo',
		'Dyatkovo',
		'Dyurtyuli',
		'Dzerzhinsk',
		'Dzerzhinskiy',
		'Dzerzhinskiy',
		'Dzerzhinsky',
		'Dzhalil',
		'Dzhaudzhikau',
		'Egorievsk',
		'Ekaterinburgo',
		'Ekaterinodar',
		'Ekazhevo',
		'Elabuga',
		'Elektrogorsk',
		'Elektrostal',
		'Elektrougli',
		'Elektrovoz',
		'Elistá',
		'Enem',
		"Engel's",
		'Engels an der Wolga',
		'Enso',
		'Ezhva',
		'Fili',
		'Finlyandskiy',
		'Five Mountains',
		'Frolovo',
		'Fryazevo',
		'Fryazino',
		'Fúrmanov',
		'Gátchina',
		'Gelendzhik',
		'Georgiu-Dezh',
		'Georgiyevsk',
		'Ghelenjik',
		'Ghiaghinskayai',
		'Glázov',
		'Glubokiy',
		'Golyanovo',
		'Gorod Murmansk',
		'Gorodovikovsk',
		'Goryachiy Klyuch',
		'Grazhdanka',
		'Grozni',
		'Gshatsk',
		'Gubkin',
		'Gudermés',
		'Gukovo',
		"Gul'kevichi",
		'Gundorovka',
		'Gusev',
		"Gus'-Khrustal'nyy",
		'Gus-Khrustalnyy',
		'Gvardeysk',
		'Gyelyendzhik',
		'Gzhatsk',
		'Hiipina',
		'Iaroslavl',
		'Ielets',
		'Iemanjelinsk',
		'Ierxov',
		'Iglino',
		'Igra',
		'Ijevsk',
		'Ilovlya',
		"Il'skiy",
		'Iman',
		'Imeni Chkalova V.P.',
		'Imeni Kirova',
		'Imeni Kost-Khetagurova',
		'Imeni Likhachëva',
		'Imeni Morozova',
		'Imeni V.P. Chkalova',
		'Inozemtsevo',
		'Insterburg',
		'Inza',
		'Ioshkar Ola',
		'Ipatovo',
		'Irbit',
		'Irkutsk',
		'Isakogorka',
		'Ishewsk',
		'Istra',
		'Iubileini',
		'Iujno-Sakhalinsk',
		'Ivángorod',
		'Ivánovo',
		'Ivanovo-Voznesensk',
		'Ivanovskoye',
		'Ivanteyevka',
		'Ivashchenkovo',
		"Ivdel'",
		'Iwanowo',
		'Ixim',
		'Izberbash',
		'Izhevsk',
		'Izhma',
		'Izluchinsk',
		'Izmaylovo',
		'Izobilno-Tishchenskiy',
		"Izobil'nyy",
		'Jamburg',
		'Jaroslavl',
		'Jefremow',
		'Jeisk',
		'Jekaterinowskaja',
		'Jelez',
		'Jelisawetinskaja',
		'Jerschow',
		'Jessentuki',
		'Jilok',
		'Jimki',
		'Jolmskaya',
		'Joschkar-Ola',
		'Jssil-Kui',
		'Jvalynsk',
		'Kaliningrado',
		'Kalininskiy',
		'Kaluga',
		"Kamen'-Rybolov",
		'Kamensk-Shakhtinsky',
		'Kamyshin',
		'Kapustin Yar-1',
		'Katav-Ivánovsk',
		'Kazán',
		'Kazran',
		'Kënisberg',
		'Khabarovsk Vtoroy',
		'Khasavyurt',
		'Khimki',
		'Khlynov',
		'Khoroshëvo-Mnevniki',
		'Khoroshëvo-Mnevniki',
		'Khutorok',
		'Kimry',
		'Kíneshma',
		'Kingisepp',
		'Kírishi',
		'Kírov',
		'Kirovo-Chepetsk',
		'Kislovodsk',
		'Kizlyar',
		'Kizyl-Yurt',
		'Kletnya',
		'Klimovo',
		'Klimovsk',
		'Klin',
		'Klintsy',
		'Klukhori',
		'Knyazepetrovski',
		'Kolomna',
		'Kolpino',
		'Komendantsky aerodrom',
		'Komintern',
		'Körigsberg',
		'Koroliov',
		'Koslov',
		'Kosta-Khetagurovo',
		'Kostromá',
		'Kovrov',
		'Krasnaya Polyana',
		'Krasnaya Presnya',
		'Krasnodar',
		'Krasnogorsk',
		'Krasnogvargeisky',
		'Krasny Stroitel',
		'Krassnyj Ssulin',
		'Kronstadt',
		'Kropotkin',
		'Krymsk',
		'Kstovo',
		'Kulebaki',
		'Kupchino',
		'Kurchatov',
		'Kurgáninsk',
		'Kurortnyy',
		'Kursk',
		'Kuzminki',
		'Kuznetsk',
		'Kuznetsovo',
		'Kyakhta',
		'Kyakisalmi',
		'Kyshtym',
		'Kyzburun Tretiy',
		'Kyzburun Vtoroy',
		'Kyzyl',
		'Labinsk',
		'Lefortovo',
		'Lenino',
		'Leninogorsk',
		'Lianozovo',
		'Likino-Dulevo',
		'Lípetsk',
		'Liúbertsy',
		'Ljuberzy',
		'Lobnya',
		'Lomonósov',
		'Lopasnya',
		'Lopatin',
		'Losinoostrovskaya',
		'Lubertsi',
		'Lublino',
		'Lyanozovo',
		'Lyskovo',
		'Lytkarino',
		'Lyubertsy',
		'Lyublino',
		'Lyublino-Dachnoye',
		'Lyudinovo',
		'Machatsch-Kala',
		'Makhachkala',
		'Malyye Mytishchi',
		'Marino',
		'Maykop',
		'Melekes',
		'Mesker-Yurt',
		'Michúrinsk',
		'Mikhaylovka',
		'Mikhaylovsk',
		'Mineral Waters',
		'Mineralnye Vody',
		'Mineralnyje Wody',
		"Mineral'nyye Vody",
		'Mitisxi',
		'Molotovsk',
		'Molotovskiy',
		'Moncha Guba',
		'Moscú',
		'Moskau-Chimki',
		'Mtsensk',
		'Múrmansk',
		'Múrom',
		'Murom am Oka',
		'Myski',
		'Mytishchi',
		'Mzensk',
		'Naberezhnye Chelny',
		'Nagornyy',
		"Nal'chik",
		'Naro-Fominsk',
		'Nasongi',
		'Nazran',
		'Nevinnomyssk',
		'Nikolayevsk',
		'Nikolskaya Pestravka',
		'Nikolskoye',
		'Nikolskoye',
		"Nikol'skoye",
		'Nizhnekamsk',
		'Nizhne-Uvelskoye',
		'Nizhniy Odes',
		'Nizhniy Teplyy Stan',
		'Nizhny Novgorod',
		'Noguinsk',
		'Novaya Igirma',
		'Novaya Pismenka',
		"Novaya Usman'",
		'Novocheboksarsk',
		'Novocherkassk',
		'Novogireyevo',
		'Novo-Kholmogory',
		'Novo-Kubanskaya',
		'Novokúibyshevsk',
		'Novo-Kuybyshevskiy',
		'Novokuzminki',
		'Novomoskovsk',
		'Novo-Peredelkino',
		'Novopismyanka',
		'Novopismyanka',
		'Novorossiysk',
		'Novoselskoye',
		'Novoshakhtinsk',
		'Novyj Hutor',
		'Novyye Cherëmushki',
		'Novyye Kuzminki',
		'Nurlat',
		'Nyagan',
		'Nyandoma',
		'Nytva',
		'Obiralovka',
		'Óbninsk',
		"Oboyan'",
		'Obruchevo',
		'Obukhovo',
		'Obukhovo',
		'Ochakovo-Matveyevskoye',
		'Ocher',
		'Ochiai',
		'Odintsovo',
		'Ódomari',
		'Oirot-Tura',
		'Oiskhara',
		'Ojshara',
		'Okha',
		"Oktyabr'sk",
		'Oktyabrskoye',
		'Oktyabrsky',
		'Oktyabrsky',
		'Okúlovka',
		'Olantsy',
		'Olzheras',
		'Omsk',
		'Omutninsk',
		'Onega',
		'Onokhoy',
		'Opochka',
		'Oranienbaum',
		'Ordzhonikidzevskaya',
		'Orechowo-Sujewo',
		'Oréjovo-Zúyevo',
		'Orekhovo-Borisovo',
		'Orekhovo-Borisovo Severnoye',
		'Orël',
		'Orjonikidze',
		'Ostankinskiy',
		'Ostrogozhsk',
		'Ostrov',
		'Otdykh',
		'Ōtomari',
		'Otradnaya',
		'Otradnoye',
		'Otradnoye',
		'Otradnyy',
		'Otrogovo',
		'Otvazhnoye',
		'Otvet Kulaku',
		'Oufa',
		'Oyskhara',
		'Ozerki',
		'Ozërnyy',
		'Ozersk',
		"Ozherel'ye",
		'Oznachennoye',
		'Ozyory',
		'Penza',
		"Pereslavl'-Zalesskiy",
		'Pervaya Rossosh',
		'Petergof',
		'Petrogradka',
		'Petrovsk',
		'Petrovsk-Port',
		'Petrozavodsk',
		'Pjatigorsk',
		'Pleskau',
		'Plyushchëvo',
		'Podolsk',
		'Pokrovsk',
		'Polyarnyye Zori',
		'Posëlok Mosgazoprovod',
		'Posëlok Nazran',
		'Poselok Tekstilshchiki',
		'Posëlok ZIL',
		'Presnenskiy',
		'Prikumsk',
		'Primorsko-Achidrskaja',
		'Primorsko-Ajtarsk',
		'Primorsko-Akhtarsk',
		'Prokhladnyy',
		'Psebay',
		'Pskov',
		'Pugachev',
		'Pushchino-na-Oke',
		'Pushkin',
		'Púshkino',
		'Pushkinskoye',
		'Pyatigorsk',
		'Pyshma',
		'Pyt-Yakh',
		'Rabochiy Poselok Imeni Gubkina',
		'Ramenki',
		'Rámenskoye',
		'Raslawl',
		'Rasskazovo',
		'Reutov',
		'Riazan',
		'Ríbinsk',
		'Rjasan',
		'Rjev',
		'Romanovskiy Khutor',
		"Rossoh'",
		'Rossosh',
		'Rostov del Don',
		'Rshew',
		'Rtíshchevo',
		'Ruzayevka',
		'Ryazan',
		'Ryazanskiy',
		'Ryazhsk',
		'Rybatskoye',
		'Rýbinsk',
		'Rybnoye',
		"Ryl'sk",
		'Rzhev',
		'Samara',
		'San Petersburgo',
		'Saransk',
		'Sarátov',
		'Schachty',
		'Schekino',
		'Seltso',
		'Sergiyev Posad',
		'Serpukhov',
		'Severnyy',
		'Severodvinsk',
		'Shajty',
		'Shcherbakov',
		'Shchukino',
		'Shchyokino',
		'Shchyolkovo',
		'Shebekino',
		'Shikhrany',
		'Shpakovskoye',
		'Shuya',
		'Sierpukhovo',
		'Siktivkar',
		'Simbirsk',
		'Skhodnya',
		'Skopin',
		'Slántsy',
		'Slavyansk-na-Kubani',
		'Sloboda',
		'Slobodka',
		'Slobodskoy',
		'Slyeptsovskaya',
		'Smolensk',
		'Snezhinsk',
		'Snezhnogorsk',
		'Sochi',
		'Sokolniki',
		'Solntsevo',
		'Sosnovka',
		'Sosnovy Bor',
		'Sotsgorod',
		'Spatowo',
		'Sredneuralsk',
		'Srednyaya Akhtuba',
		'Srednyaya Akhtuba',
		'Ssalsk',
		'Sslawgorod',
		'Sslawjanskaja',
		'Ssotschi',
		'Stakhanovo',
		'Stalinogorsk',
		'Stalinogorsk Pervyy',
		'Stalinogorsk Severnyy',
		'Stalinogorsk Vtoroy',
		'Stalinogorsk Yuzhnyy',
		'Staraya Russa',
		'Staro Khasav-Yurt',
		'Stary Oskol',
		'Starye Otagi',
		'Staryye Atagi',
		'Stavropol',
		'Stepnoy',
		'Strogino',
		'Sudostroy',
		'Sunzha',
		'Svenigorod',
		'Sverdlovsk-44',
		'Svetlanovskiy',
		'Svetlogorsk',
		'Svetlograd',
		'Svetlyy',
		'Svetlyy',
		'Svetlyy Yar',
		'Svetogorsk',
		'Sviblovo',
		'Svoboda',
		'Svobody',
		'Svyatoy Krest',
		'Swenigorod',
		"Syas'stroy",
		'Syktyvkar',
		'Syrkhokh',
		"Sysert'",
		'Syuginskaya',
		'Syzran',
		'Taganrog',
		'Taganskiy',
		'Tambov',
		'Tbilisskaya',
		'Tcheliabinsk',
		'Tchita',
		'Tekstilshchiki',
		'Temir-Khan-Shura',
		'Tijoretsk',
		'Tijvin',
		'Tilsit',
		'Tilzit',
		'Timashyovsk',
		'Togliatti-on-the-Volga',
		'Toliatti',
		"Tol'yatti",
		'Torgovyy',
		'Trotsk',
		'Tsarevokokshaysk',
		'Tsaritsyno',
		'Tsaritsyno-Dachnoye',
		'Tschapajewsk',
		'Tscheboksary',
		'Tscherkessk',
		'Tschernjanka',
		'Tschir-jurt',
		'Tschudowo',
		'Tsimlyansk',
		'Tsivilsk',
		'Tsotsin-Yurt',
		'Tuapsé',
		'Tula',
		'Tutayev',
		"Tver'",
		'Twer',
		'Txeboksari',
		'Txeliàbinsk',
		'Txerepovets',
		'Txernogolovka',
		'Tyemryuk',
		'Tynda',
		'Tyoply Stan',
		'Tyrny-Aus',
		'Tyrnyauz',
		'Tyumen',
		'Uchaly',
		'Uchkeken',
		'Udachni',
		'Udelnaya',
		'Udomlya',
		'Ufá',
		'Uglegorsk',
		'Uglich',
		'Uglovoye',
		'Ugodskiy Zavod',
		'Ugolnye Kopi',
		'Ugolnyy',
		'Ujtá',
		'Ukhta',
		'Ulán-Udé',
		'Uliánovsk',
		'Ulin',
		'Uljanowska am Wolga',
		'Ulyanovsk',
		'Umanskaya',
		'Unecha',
		'Untolovo',
		'Urajimirofuka',
		"Uren'",
		'Uritsk',
		'Urupskaya',
		'Urús-Martán',
		'Urussu',
		'Uryupinsk',
		'Urzhum',
		'Usinsk',
		"Usman'",
		'Uspenskoye',
		'Ustar-Gordoy',
		'Ust-Belokalitvenskaya',
		'Ust-Cheptsa',
		"Ust'-Donetskiy",
		"Ust'-Dzheguta",
		'Ust-Dzheguta',
		'Ustinov',
		'Ustiuzhna',
		'Ust-Kinelskiy',
		"Ust'-Labinsk",
		'Ust-Sysolsk',
		'Utesnaya',
		'Uva',
		'Uvarovo',
		"Uvel'skiy",
		'Uya',
		'Uyar',
		'Uzhur',
		'Uzhur-4',
		'Uzlovaya',
		"Vasyl'evsky Ostrov",
		'Veliki Nóvgorod',
		'Velikiy Ustyug',
		'Velikiye Luki',
		'Verkhniy Ufaley',
		'Verkhnyaya Pyshma',
		'Veshnyaki',
		'Viatka',
		'Víborg',
		'Viksa',
		'Vladicáucaso',
		'Vladímir',
		'Vladivostok',
		'Vladykino',
		'Vnukovo',
		'Volgodonsk',
		'Volgogrado',
		'Vóljov',
		'Volkhonka',
		'Vólogda',
		"Vol'sk",
		'Volzh Sky',
		'Volzhsk',
		'Volzhsky',
		'Vorkutá',
		'Vorobyëvskiy',
		'Vorobyovo',
		'Voronezh',
		'Voroshilovsk',
		'Voskresensk',
		'Vostochnoe Degunino',
		'Vótkinsk',
		"Vrangel'",
		'Vrjupinsk',
		'Vsévolozhsk',
		'Vtoroy Gorodok',
		'Vuktyl',
		'Vurnary',
		'Vyatka',
		'Vyatskiye Polyany',
		'Vyazemskiy',
		'Vyazma',
		'Vyazniki',
		'Vyborg',
		'Vychegodskiy',
		'Vykhino-Zhulebino',
		'Vyksa',
		'Vyritsa',
		'Vyru Pechory',
		'Vyselki',
		'Vyshny Volochyok',
		'Vysokovsk',
		'Vytegra',
		'Welikije Luki',
		'Wiborg',
		'Wjasnik',
		'Wjatka',
		'Wladikawkas',
		'Wladimir',
		'Wologda',
		'Wolsk',
		'Woronesh',
		'Woronzowo-Alexandrowskoje',
		'Woskressensk',
		'Wyschni-Wolotschek',
		'Wystruć',
		'Wytegra',
		'Xalí',
		'Xarípovo',
		'Ximanovsk',
		'Xúia',
		'Xúmerlia',
		'Yablonovski',
		'Yagry',
		'Yamburg',
		'Yaroslavl',
		'Yaroslavskiy',
		'Yartsevo',
		'Yasenevo',
		'Yefrémov',
		'Yegorevsk',
		'Yekaterinenshtadt',
		'Yekaterinodar',
		'Yelabuga',
		'Yelets',
		"Yel'nya",
		'Yessentuki',
		'Yeysk',
		'Yezhovo-Cherkessk',
		'Yiesk',
		'Yoshkar-Ola',
		'Yubileyny',
		'Yuryevets',
		'Yuryev-Polskiy',
		'Yushkovo',
		'Yuzha',
		'Yuzhno-Sajalinsk',
		'Yuzhno-Sukhokumsk',
		'Yuzhnyy',
		'Zagorsk',
		'Zaínsk',
		'Zamoskvorechye',
		'Zarechnyy',
		'Zavety Ilicha',
		"Zavolzh'ye",
		'Zelenchukskaya',
		'Zelenodolsk',
		'Zelenograd',
		'Zelenogradsk',
		'Zelenokumsk',
		'Zernograd',
		'Zheleznodorozhnyy',
		'Zheleznodorozhnyy',
		'Zheleznogorsk',
		'Zheleznogorsk',
		'Zheleznovodsk',
		'Zherdevka',
		'Zhezhoro-Cherkessk',
		'Zhigulevsk',
		'Zhirnovsk',
		'Zhukovka',
		'Zhukovo',
		'Zhukovsky',
		'Zhulebino',
		'Zima',
		'Zimovniki',
		'Zlatoust',
		'Zlatoust-26',
		'Zmeinogorsk',
		'Znamenka',
		'Známensk',
		'Znamenskoye',
		'Znamenskoye',
		'Zolodary',
		'Zvanka',
		'Zvenígorod',
		'Zvenigovo',
		'Zverevo',
		'Zyablikovo',
		'Zymljanskaja',
		'Zyuzino',
	],
	Serbia: [
		'Abthausen',
		'Apatin',
		'Belgrado',
		'Čačak',
		'Cubin',
		'Futog',
		'Hertelendyfalva',
		'Indjija',
		'Ivranya',
		'Jagodina',
		'Kiszombor',
		'Knjazevac',
		'Kragujevac',
		'Kraljevo',
		'Kruševac',
		'Leskovac',
		'Nagybecskerek',
		'Nagy-Zombor',
		'Neoplanta',
		'Niš',
		'Novi Pazar',
		'Novi Sad',
		'Ófutak',
		'Ópalánka',
		'Ópázova',
		'Oujiste',
		'Palanka Smederevska',
		'Pančevo',
		'Pétervárad',
		'Petrovgrad',
		'Pirot',
		'Plakenburg',
		'Rankovićevo',
		'Ruma',
		'Schomburg',
		'Singidunum',
		'Smederevo',
		'Sremčica',
		'Sremska Kamenica',
		'Srijemska Mitrovica',
		'Subotica',
		'Syrmisch-Mitrowitz',
		'Szabadka',
		'Szávaszentdemeter',
		'Szénta',
		'Szentmihály',
		'Theresiopel',
		'Titov Vrbas',
		'Titov Vrbas',
		'Titovo Užice',
		'Trstenik',
		'Újfutak',
		'Újpalánka',
		'Újpázova',
		'Újvidék',
		'Ungarisch Weisskirchen',
		'Ungarisch-Kanischa',
		'Užice',
		'Valjevo',
		'Vásáros-Várad',
		'Veliki Bečkerek',
		'Vojlovica',
		'Vranje',
		'Vrnjačka Banja',
		'Vršac',
		'Werschitz',
		'Wojlowitz',
		'Yeni Pazar',
		'Zaječar',
		'Zemun',
		'Zenta',
		'Zombor',
		'Zrenjanin',
		'Zrenjanin-grad',
		'Zubotica',
	],
	Siria: [
		'Aafrîne',
		'Aâmoûda',
		'Aarbîl',
		'Aazâz',
		'Aeré',
		'Afrin',
		'Aïn el Aarab',
		'Al-Shām',
		'Al-Sweida',
		'Ayn al Arab',
		'Azaz',
		'Cham',
		'Damasco',
		'Deir Azzor',
		'Deir ez-Zor',
		'Deir Zzor',
		'Der Ezzor',
		'Dimashk',
		'Djarablous',
		'Djéblé',
		'Djerud',
		'Djisr el Choghour',
		'El Hrâk',
		'El Qnaïtra',
		'El Qoussair',
		'El Qtaïfé',
		'Epiphania',
		'Esh Shām',
		'Ett Tell',
		'Ezra',
		'Ezzaz',
		'Idlib',
		'Ifrīn',
		'Imranie',
		'Irbin',
		'Izaz',
		'Izra',
		'Jirāblus',
		'Jisr ash Shughūr',
		'Jisr ech Chorhour',
		'Kafer Tkherim',
		'Kafr Nubul',
		'Omranié',
		'Philppopolis',
		'Qabbāsīn',
		'Qhaitra',
		'Qoubbâssîne',
		'Sfaireh',
		'Ţayyibat al Imām',
		'Umraniya',
	],
	Suecia: [
		'Åkersberga',
		'Avesta',
		'Björlanda',
		'Bjuv',
		'Celfsborg',
		'Ekerö',
		'Eksjö',
		'Enköping',
		'Eskilstuna',
		'Estocolmo',
		'Falkenberg',
		'Falun',
		'Gamla Uppsala',
		'Gävle',
		'Gotemburgo',
		'Helsingborg',
		'Huddinge',
		'Huskvarna',
		'Jönköping',
		'Kungsbacka Skene',
		'Kungsholmen',
		'Linköping',
		'Ljungby',
		'Luleå',
		'Lund',
		'Malmö',
		'Mjölby',
		'Norrköping',
		'Nybro',
		'Nyköping',
		'Nynäshamm',
		'Onsala',
		'Örebro',
		'Örnsköldsvik',
		'Östermalm',
		'Östersund',
		'Oxelösund',
		'Oxie',
		'Skellefteå',
		'Skövde',
		'Södermalm',
		'Södertälje',
		'Sollentuna',
		'Stockholm',
		'Sundsvall',
		'Svedala',
		'Trollhättan',
		'Tukholma',
		'Tumba',
		'Uddevalla',
		'Ulricehamn',
		'Umeå',
		'Upplands Vasby',
		'Upsala',
		'Västerås',
		'Vaxjo',
		'Ystad',
	],
	Suiza: [
		'Aarau',
		'Adliswil',
		'Aesch',
		'Affoltern',
		'Aussersihl',
		'Basilea',
		'Berna',
		'Biel-Bienne',
		'Ebikon',
		'Écublens',
		'Effretikon',
		'Einsiedeln',
		'Emmen',
		'Friburgo',
		'Geneva',
		'Ginebra',
		'Kloten',
		'La Chaux-de-Fonds',
		'Lausana',
		'Lucerna',
		'Lugano',
		'Nyon',
		'Oerlikon',
		'Oftringen',
		'Onex',
		'Plan-les-Ouates',
		'San Galo',
		'Schaffhausen',
		'Spiez',
		'Spreitenbach',
		'Thun',
		'Unterstrass',
		'Uster',
		'Uster / Kirch-Uster',
		'Uzwil',
		'Winterthur',
		'Wülflingen (Kreis 6)',
		'Yverdon',
		'Zofinguen',
		'Zug',
		'Zúrich',
		'Zürich (Kreis 10)',
		'Zürich (Kreis 11)',
		'Zürich (Kreis 12)',
		'Zürich (Kreis 2)',
		'Zürich (Kreis 3)',
		'Zürich (Kreis 3) / Sihlfeld',
		'Zürich (Kreis 4) / Aussersihl',
		'Zürich (Kreis 6)',
		'Zürich (Kreis 6) / Unterstrass',
		'Zürich (Kreis 7)',
		'Zürich (Kreis 9)',
		'Zürich (Kreis 9) / Altstetten',
	],
	Tayikistán: [
		'Djuschambe',
		'Dushanbe',
		'Dyushambe',
		'Jushambe',
		'Kurgan-Tyube',
		'Stalinabad',
		'Ura-Tyube',
		'Ŭroteppa',
		'Ursaten',
		'Yovon',
	],
	Turkmenistán: ['Asjabad', 'Gaz-Achak', 'Gyzylarbat', 'Iolotan', 'Iyanli', 'Yolöten', 'Yylanly'],
	Turquía: [
		'Abydus',
		'Acarlar',
		'Achyraus',
		'Acıpayam',
		'Acroënus',
		'Ada Bazar',
		'Adağmadenı',
		'Adalia',
		'Adana',
		'Adapazarı',
		'Adilcevaz',
		'Adiyaman',
		'Adramyti',
		'Adrianople',
		'Adrianouthērai',
		'Aegialis',
		'Afıon Karahissar',
		'Afiun Qarahisar',
		'Afiun-Carahissar',
		'Afşin',
		'Afyonkara Hisar',
		'Afyonkarahisar',
		'Ağrı',
		'Agrilium',
		'Ağros',
		'Ahiköy',
		'Ahlat',
		'Ahmetli',
		'Aïdin',
		'Aintab',
		'Aïrandji',
		'Aivali',
		'Ak Hisar',
		'Ak Shehr',
		'Ak Yokuş',
		'Akçaabat',
		'Akçadağ',
		'Akçakale',
		'Akçakoca',
		'Akçapınar',
		'Akdağ',
		'Akdağmadeni',
		'Akhisar',
		'Akköy',
		'Akmescit',
		'Aksaray',
		'Akşehir',
		'Aksu',
		'Akyazı',
		'Akyurt',
		'Ala Shehr',
		'Alanya',
		'Alejandreta',
		'Alevışık',
		'al-Rūhā',
		'Amasya',
		'Amida',
		'Amisus',
		'Anamur',
		'Ankara',
		'Antalya',
		'Antiochia ad Cydnum',
		'Antioquía',
		'Antoninopolis',
		'Apamea',
		'Apamea Cibotus',
		'Aphrike',
		'Apsarus',
		'Arcis',
		'Ard-ar-Rum',
		'Ardeşen',
		'Arghana',
		'Arnavutköy',
		'Arseni Zir',
		'Arzanjan',
		'Asıyozgat',
		'Astacus',
		'Atabey',
		'Ataşehir',
		'Atrabazandah',
		'Attalia',
		'Avanos',
		'Avsallar',
		'Axari',
		'Ayancık',
		'Ayasoluk',
		'Aydin',
		'Ayıntap',
		'Ayranci',
		'Ayvalık',
		'Azarion',
		'Aziris',
		'Aziziye',
		'Aziziye',
		'Azmir',
		'Bağcılar',
		'Bahçelievler',
		'Balikesir',
		'Bali-Kessir',
		'Baris',
		'Başakşehir',
		'Batikent',
		'Batman',
		'Bechirias',
		'Beit Zabde',
		'Belikesir',
		'Bender-Ereğli',
		'Beylikduzu',
		'Bilecik',
		'Bingöl',
		'Birecik',
		'Bismil',
		'Bitlis',
		'Bolu',
		'Bourdour',
		'Boursa',
		'Brusa',
		'Burdur',
		'Bursa',
		'Büyükçekmece',
		'Caesarea',
		'Caesarea Germanicia',
		'Caesarea Trocetta',
		'Çanakkale',
		'Çankaya',
		'Çapakçur',
		'Carana',
		'Carbanum',
		'Castamon',
		'Cebelibereket',
		'Celaenae',
		'Cerasus',
		'Çerkezköy',
		'Césarée',
		'Çevlik',
		'Ceyhan',
		'Chanak',
		'Choerades',
		'Chorlu',
		'Chorum',
		'Chrysopolis',
		'Ciliza',
		'Cisthene',
		'Cius',
		'Cizre',
		'Claudiopolis',
		'Cocaeli',
		'Conia',
		'Coracesium',
		'Çorlu',
		'Çorum',
		'Çorum',
		'Cotyaeum',
		'Crateia Flaviopolis',
		'Çubuk',
		'Çukur',
		'Cumaovası',
		'Çumra',
		'Cybistra',
		'Cylanpinar',
		'Dardanelles',
		'Darende',
		'Dazimon',
		'Denizli',
		'Derince',
		'Diari-Békir',
		'Diyarbakır',
		'Djanik',
		'Doğubeyazıt',
		'Dörtyol',
		'Düzce',
		'Dzheylanpynar',
		'Dzhizre',
		'Edirne',
		'Edremit',
		'Efes',
		'Efsus',
		'Eğirdir',
		'Ekşinoz',
		'Elâzığ',
		'Elbistan',
		'Elevi',
		'Elmadağ',
		'Emet',
		'Eminönü',
		'Emirdağ',
		'Endires',
		'Engüri',
		'Ephesus',
		'Epibates',
		'Erbaa',
		'Erciş',
		'Erdemli',
		'Ereğli',
		'Ereğli',
		'Ergani',
		'Erkizan',
		'Erzin',
		'Erzincan',
		'Erzurum',
		'Esenler',
		'Esenyurt',
		'Eski Adalia',
		'Eski Shehir',
		'Eski-chéhir',
		'Eskişehir',
		'Esmirna',
		'Estambul',
		'Estil',
		'Euchaita',
		'Eudemish',
		'Eusebeia',
		'Evrek',
		'Eynesil',
		'Eynihal',
		'Ezine',
		'Fatsa',
		'Ferizli',
		'Feteköy',
		'Fethiye',
		'Flaviopolis',
		'Flaviopolis',
		'Gangra Germanicopolis',
		'Gaziantep',
		'Gebelibereket',
		'Gebze',
		'Gemlik',
		'Germanicea Marqasi',
		'Germe',
		'Geulzuk',
		'Geyiklar',
		'Ghanjarah',
		'Gherzeh',
		'Giresun',
		'Girikoma',
		'Gölcük',
		'Guebze',
		'Gümüşhane',
		'güngören merter',
		'Gürele',
		'Gürpınar',
		'Hadrianople',
		'Hadrianutherae',
		'Hamid',
		'Hamid-Abad',
		'Hamidiye',
		'Hatay',
		'Heraclea',
		'Heraclea Pontica',
		'Heracleia Minoa',
		'Heraklea',
		'Herek',
		'Hilvan',
		'Hisnumansur',
		'Humurgân',
		'Hüseynabat',
		'Hüsnümansur',
		'Hüvek',
		'Hypaepa',
		'Iconium',
		'İdil',
		'Iğdır',
		'İğneabat',
		'İkizce',
		'Ikoniow',
		'Ilgaz',
		'Ilgın',
		'Ilıca',
		'Iloh',
		'İmamoğlu',
		'İncili',
		'İncirliova',
		'İnegöl',
		'İnevi',
		'Iraklia',
		'İskenderun',
		'İskilip',
		'Ismir',
		'Ismit',
		'Isnik',
		'Isparta',
		'Istanbul',
		'İstanos',
		'Ivanski',
		'Izmir',
		'İzmit',
		'Íznik',
		'İzparta',
		'Janik',
		'Jazirhe-a-ibn-a Omar',
		'Jehan',
		'Jesıret ibn Omar',
		'Jidde',
		'Julamerk',
		'Justinianopolis',
		'Kahramanmaraş',
		'Kale-Sultanie',
		'Kara Hissar Sahib',
		'Kara-Agach',
		'Karabağlar',
		'Karabük',
		'Karaköse',
		'Karaman',
		'Karassi',
		'Karin',
		'Kasaba',
		'Kastamonu',
		'Kayseri',
		'Kerasunt',
		'Khandak',
		'Khanjarah',
		'Kilis',
		'Kiresun',
		'Kirk Kilise',
		'Kirmasti',
		'Kirshehr',
		'Kiye',
		'Koçhisar',
		'Kodja-Eli',
		'Koja-Ili',
		'Konya',
		'Konyaereğlisi',
		'Körfez',
		'Kozan',
		'Kükes',
		'Kulu',
		'Kumru',
		'Kuniyah',
		'Kurtalan',
		'Kusadasi',
		'Kush Adası',
		'Kütahya',
		'Kydoniai',
		'Kyzyltepe',
		'Laranda',
		'Lozen',
		'Lule Burgas',
		'Lüleburgaz',
		'Malatya',
		'Manisa',
		'Maraş',
		'Mazaca',
		'Medeat',
		'Megalopolis',
		'Melitene',
		'Mentese',
		'Merkezefendi',
		'Mersin',
		'Mezreh',
		'Midyat',
		'Miepherkeim',
		'Mobolla',
		'Mokissus',
		'Muğla',
		'Muhalich',
		'Muratpaşa',
		'Muş',
		'Muşkara',
		'Mustafakemalpaşa',
		'Mut',
		'Mylasa',
		'Myriandrus',
		'Myrlea Apamea',
		'Nasabina',
		'Nazilli',
		'Nea Ephesus',
		'Nevşehir',
		'Nezip',
		'Niğde',
		'Nikomedeia',
		'Niksar',
		'Nisibis',
		'Nizip',
		'Nurdağı',
		'Nuseybin',
		'Nymphaeum',
		'Oba',
		'Ödemiş',
		'Odrin',
		'Oenoe',
		'Off',
		'Oğuzeli',
		'Olbia',
		'Onieh',
		'Ophius',
		'Opsicium',
		'Ordu',
		'Orfa',
		'Orhangazi',
		'Ortaköy',
		'Osmancık',
		'Osmaniye',
		'Osmaniye',
		'Ouchak',
		'Ourfa',
		'Özdere',
		'Panormus',
		'Parthenium',
		'Patnos',
		'Paura',
		'Pazarköy',
		'Perre',
		'Phadısana',
		'Pharnacia',
		'Phaselis',
		'Phazemon',
		'Philocalia',
		'Philomelium',
		'Phocaea',
		'Physcus',
		'Pimolisa',
		'Platana',
		'Playa',
		'Polatlı',
		'Polydorion',
		'Pordonnium',
		'Prousa',
		'Provincia de Bayburt',
		'Provincia de Tokat',
		'Pulandjak',
		'Pulathane',
		'Pythiae Thermae',
		'Qaisariye',
		'Qars',
		'Qastamuni',
		'Qonia',
		'Rass-el-Aïn',
		'Rayḩānīyah',
		'Reyhanlı',
		'Rhizus',
		'Rize',
		'Şamān Dāghī',
		'Samsun',
		'Sanliurfa',
		'Saranta Ekklēsiai',
		'Saruhan',
		'Satalia',
		'Scalanuova',
		'Scutari',
		'Seleucia',
		'Seleucia Pieria',
		'Sevas',
		'Severek',
		'Shirnak',
		'Side',
		'Siirt',
		'Silifke',
		'Silopi',
		'Silvan',
		'Sis',
		'Şişli',
		'Sivas',
		'Siverek',
		'Skalanova',
		'Skutari',
		'Söke',
		'Songuldak',
		'Sparta',
		'Sultanbeyli',
		'Sultangazi',
		'Sungul',
		'Suverek',
		'Suwaydīyah',
		'Synaus',
		'Syurmene',
		'Syuryuch',
		'Tarabazandah',
		'Tarso',
		'Tatvan',
		'Tchataldja',
		'Teıra',
		'Tekirdağ',
		'Telmessus',
		'Temenothyrae',
		'Temnos',
		'Themiscyra',
		'Theodosiopolis',
		'Thermae Phazemonitarum',
		'Thireh',
		'Thospia',
		'Thyatira',
		'Tirabzon',
		'Tire',
		'Torbalı',
		'Tralleis',
		'Trebisonda',
		'Tschataldja',
		'Tukat',
		'Tunceli',
		'Turgutlu',
		'Turhal',
		'Tyriaeum',
		'Tzevislik',
		'Tzirallum',
		'Uluborlu',
		'Umraniye',
		'Umurlu',
		'Unie',
		'Urartu',
		'Urfeh',
		'Ürgüp',
		'Urla',
		'Ürmeli',
		'Uşak',
		'Üsküdar',
		'Üzümlü',
		'Uzunköprü',
		'Van',
		'Vanand',
		'Vaskovan',
		'Veeranshahr',
		'Viranşehir',
		'Vourlah Skala',
		'Wan',
		'Wiranschehir',
		'Yalova',
		'Yalvaç',
		'Yarımca',
		'Yarpuz',
		'Yazmir',
		'Yenişehir',
		'Yerköy',
		'Yerznka',
		'Yeşilkent',
		'Yeşilli',
		'Yeşilova',
		'Yomra',
		'Yoran',
		'Yozgat',
		'Yukarı Alevışık',
		'Yukarı Hadım',
		'Yukarı Kocaali',
		'Yukarıdoğncılar',
		'Yüksekova',
		'Yunak',
		'Yuzgat',
		'Zafranboli',
		'Zephyrium',
		'Zeugma',
		'Zeydekan',
		'Zeytinburnu',
		'Zidikân',
		'Zile',
		'Zonguldak',
		'Zorlanae',
		'Zümrütkaya',
		'Zunguldak',
	],
	Ucrania: [
		'Achtyrka',
		'Akhtyar',
		'Akhtyrka',
		"Alchevs'k",
		'Amvrosiyivka',
		'Antratsit',
		'Apostolove',
		'Avdiivka',
		'Belaja Zerkow',
		'Belskiy Gorodok',
		'Berdyansk',
		'Bila Tserkva',
		'Bilhorod-Dnistrovsky',
		'Bilhorod-Dnistrovskyi',
		'Brovary',
		'Bryanskiy Rudnik',
		'Bychansk',
		'Cernăuţi',
		'Cervonohrad',
		'Charkow',
		'Cherkasy',
		'Chernígov',
		'Chernivtsi',
		'Cív',
		'Czerwonohrad',
		'Dachi Bucha',
		'Dachi Irpen',
		'Debaltsevo',
		'Dnipro',
		'Dniprorudne',
		'Donetsk',
		'Dovzhansk',
		'Drohobych',
		'Druzhkivka',
		'Dshankoi',
		'Dubno',
		'Dzhankoi',
		'Enerhodar',
		'Fastiv',
		'Feodosiya',
		'Fyeodosiya',
		'Glukhov',
		'Górlovka',
		'Grudek Yagellonski',
		'Hlújiv',
		'Hnivan',
		'Horishni Plavni',
		'Horlivka',
		'Hrebinka',
		'Hughesovka',
		'Hvardiiske',
		'IAsinovataia',
		'Ichnya',
		'Illintsi',
		"Ilovays'k",
		'Imeni Kaganovicha',
		'Imeni Karla Libknekhta',
		'Imeni Petrovskogo',
		'Imeni Yunykh Kommunarov',
		'Irpin',
		'Itschnja',
		'Ivano-Frankivsk',
		'Iziaslav',
		'Izium',
		'Izmaíl',
		'Jalta',
		'Jarkov',
		'Jersón',
		'Jitomir',
		'Jusowka',
		'Jytómyr',
		'Kamianets-Podilskyi',
		'Kamianske',
		'Kamyanka-Dniprovska',
		'Kerch',
		'Kharkiv',
		'Kharkov',
		'Khartsyzk',
		'Kherson',
		'Khmelnytskyi',
		'Khrustalnyi',
		'Khust',
		'Kíev',
		'Kommunarsk',
		'Konotop',
		'Kramatorsk',
		'Krasnoarmeyskiy Rudnik',
		'Krasnodon',
		'Krassnoarmeiskoje',
		'Krementxuk',
		'Kropyvnytskyi',
		'Krvstonopol',
		'Kryvy Rig',
		'Kyiv',
		'Leópolis',
		'Lisichansk',
		'Lozova',
		'Luhansk',
		'Lutsk',
		'Lviv',
		"L'vov",
		'Lysychansk',
		'Lyubotyn',
		'Makiivka',
		'Mala Vyska',
		'Mariupol',
		'Melitopol',
		'Mostsiska',
		'Mukachevo',
		'Mykhaylivka',
		'Mykolaiv',
		'Mykolaivka',
		'Mykolayiv',
		'Myrhorod',
		'Myrnohrad',
		'Myronivka',
		'Nezhin',
		'Nikopol',
		'Nizhyn',
		'Nova Odesa',
		"Novhorod-Sivers'kyy",
		'Novograd-Volynsk',
		'Novohrad-Volynskyy',
		'Novomoskovsk',
		'Novo-Ulakly',
		'Nowograd Wolynsk',
		'Nyzhnya Krynka',
		'Obukhiv',
		'Ochakiv',
		'Odesa',
		'Okhtyrka',
		'Oktyabrskoye',
		'Oleksandriia',
		'Oleshky',
		'Olwiopol',
		'Ordzhonikidze',
		'Otxàkiv',
		'Ovidiopol',
		'Ovruch',
		'Owidiopol',
		'Owrutsch',
		'Pavlohrad',
		'Pervomaisk',
		"Pervomays'kyy",
		'Poltava',
		'Pryluky',
		'Pyatykhatky',
		'Pyriatyn',
		'Rivne',
		'Rovno',
		'Rubizhne',
		'Ruvne',
		'Rykovo',
		'Schostka',
		'Sevastopol',
		'Severodonetsk',
		'Shakhtarsk',
		'Shezhnoye',
		'Shitomir',
		'Shostka',
		'Sievierodonetsk',
		'Simferópol',
		'Skvyra',
		'Slavuta',
		'Slavutych',
		"Slov”yans'k",
		'Sloviansk',
		'Smigirevk',
		'Smila',
		'Snigirëvka',
		'Snizhne',
		'Snovsk',
		'Spartakovka',
		'Stalino',
		'Sumy',
		'Svaliava',
		'Svatove',
		'Svetlodarsk',
		'Svitlovodsk',
		'Swatowo',
		"Syeverodonets'k",
		'Synelnykove',
		'Ternopil',
		'Theodosia',
		'Tschernigow',
		'Tschistjakowa',
		'Tschugujew',
		'Txerkassi',
		'Txerníhiv',
		'Txernivtsí',
		'Ukrainka',
		'Ukrainsk',
		'Uman',
		'Úzhgorod',
		'Uzyn',
		'Vinnytsia',
		'Vladimir-Volynsk',
		'Volodymyr-Volynskyy',
		'Voroshilovsk',
		'Vynohradiv',
		'Vyshhorod',
		'Vyshneve',
		'Vysokyy',
		'Wassilkow',
		'Wladimir-Wolynsk',
		'Woroschilowsk',
		'Yalta',
		'Yasynuvata',
		'Yenakiieve',
		'Yevpatoria',
		'Yunyy Kommunar',
		'Yuzhne',
		'Yuzhnoukrainsk',
		'Yuzovo',
		'Zapadno-Gruppskiy',
		'Zaporiyia',
		'Zbarazh',
		'Zdolbuniv',
		'Zhashkiv',
		'Zhdanovka',
		'Zhmerynka',
		'Zhovkva',
		'Zhovti Vody',
		'Zhytomyr',
		'Zlochuv',
		'Zmiyiv',
		'Znamianka',
		'Żółkiew',
		'Zolochiv',
		'Zolotonosha',
		'Zolotoye',
		'Zuhres',
		'Zvenihorodka',
		'Zviáhel',
		'Zwiahl',
		'Żytomierz',
	],
	Uzbekistán: [
		'Djizaks',
		'Dzhalair',
		'Dzhalakuduk',
		'Dzhizak',
		'Ghijduwon',
		'Gijduvon Shahri',
		'Guzor',
		'Gydzha-Dovan',
		'Ilichevsk',
		'Imeni Ilicha',
		'Jiva',
		'Jizzakh',
		'Kolkhoz Imeni Akhunbabayeva',
		'Kyzyltepa',
		'Kyzyl-Tepa',
		'Margilon',
		'Nukus',
		'Nurafshon',
		'Ohangaron',
		'Okhangaron',
		'Oqqŭrghon',
		'Oqtosh',
		'Oyim',
		'Pskent',
		'Qarshi',
		'Qibray',
		'Qiziltepa',
		'Qoqon',
		'Qorakŭl',
		'Qorasuw',
		'Qorgontepa',
		'Shorchi',
		'Ssyr-Darja',
		'Syrdarya',
		'Taskent',
		'Toi-Tjube',
		'Torqaorgon',
		'Toshkent',
		'Toy-Tyube',
		'Tyurya-Kurgan',
		'Uchkuduk',
		'Uchqŭrghon',
		'Uichi',
		'Ulyanovo',
		'Ungi-Yere',
		'Uychi',
		'Vrevskiy',
		'Xahrisabz',
		'Xiva',
		'Xonobod',
		'Yrgench',
		'Zheleznodorozhnyy',
	],
	Vaticano: ['Vaticano'],
};